PJQ.views.timecards = {};

PJQ.constants.timecards = {
    view: {
        BY_TIMECARD: "timecard",
        BY_TIMECARD_GROUP: "timecard-group",
        BY_PROJECT: "project",
        BY_PROJECT_CONTACT: "project-contact",
        BY_PROJECT_CONTACT_TIMECARD: "project-contact-timecard",
        BY_CONTACT: "contact",
        BY_CONTACT_PROJECT: "contact-project",
        BY_CONTACT_PROJECT_TIMECARD: "contact-project-timecard",
        BY_TIMECARD_DATAENTRY: "timecard-dataentry",
        BY_TIMECARD_GROUP_DATAENTRY: "timecard-group-dataentry",
        PROJECTWALL_BY_TIMECARD: "projectwall-timecard"
    },
    defaultDateRange: {
        WEEK_TO_DATE: 0,
        DAYS_7: 7,
        DAYS_14: 14,
        DAYS_28: 28,
        MONTH_TO_DATE: -1
    },
    selectionMode: {
        NONE: 0,
        APPROVE: 1,
        UNAPPROVE: 2
    },
    manageTimeCards: {
        stage: {
            SELECT_DATE: 0,
            SELECT_PROJECT: 1,
            SELECT_CONTACTS: 2,
            MANAGE_TIMECARDS: 3
        }
    },
    timeCardGroupBy: {
        CONTACT: 'contact',
        DATE: 'date'
    }
};

PJQ.helpers.timecards = {};

if (PJQ.app.module === PJQ.constants.modules.TIMECARDS) {
    PJQ.app.addOldRoutes([
        {
            route: '',
            name: 'default',
            callback: function () {
                PJQ.app.router.navigate('timecards', {
                    trigger: true,
                    replace: true
                });
            }
        }
    ]);
}

PJQ.modules.timecards = {
    routes: [
        {
            route: 'timecards',
            name: 'timecards',
            callback: function () {
                PJQ.app.session.project = null;
                if (PJQ.app.module === PJQ.constants.modules.APP) {
                    if (PJQ.app.session.get('ownsPortal')) {
                        PJQ.app.initNavigator({
                            activeItem: "timecards"
                        });
                    }
                    else {
                        PJQ.app.initNavigator();
                    }
                }
                else {
                    PJQ.app.view.renderView(PJQ.views.timecards.TimeCardMain);
                }
            }
        },
        {
            route: 'projects/:projectId/timecards',
            name: 'timecardsProject',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "timecardsProject");
            }
        },
        {
            route: 'projects/:projectId/crews',
            name: 'crews',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "crews");
            }
        },
        {
            route: 'projects/:projectId/equipment',
            name: 'equipment',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "crews", {
                    view: 'equipment'
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.timecards.routes);


PJQ.views.timecards.CrewsAndEquipmentDashboard = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'crews-and-equipment-dashboard'),
        view: null
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated'
    },
    beforeFirstRender: function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.options.canManageCrews = this.options.project.hasPermission('timeCards.canManageCrews');
        this.options.canManageEquipment = this.options.project.hasPermission('timeCards.canManageEquipment');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            canManageCrews: this.options.canManageCrews,
            canManageEquipment: this.options.canManageEquipment,
        }
    },
    afterRender: function () {
        this.crewsView = null;
        this.equipmentView = null;

        if (this.options.view != null) {
            this.activateTab(this.options.view);
        }  else {
            this.activateTab('crews');
        }
    },
    activateTab: function (tab) {
        this.activeView = tab;

        if(tab === 'equipment' && !this.options.canManageEquipment){
            tab = 'crews';
        } else if(tab === 'crews' && !this.options.canManageCrews){
            tab = 'equipment';
        }

        switch (tab ? tab.toLowerCase() : null) {
            case 'equipment':
                tab = 'E_List';
                this.renderEquipmentView();
                break;
            default:
                tab = 'C_List';
                this.renderCrewsView();
                break;
        }

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;
    },
    tabActivated: function (e) {
        if(this.isActivating){
            return;
        }

        this.activeTab = $(e.target).attr('href');

        let vw;
        switch (this.activeTab) {
            case '#C_List':
                vw = 'crews';
                break;
            case '#E_List':
                vw = 'equipment';
                break;
        }
        this.activateTab(vw);
    },
    renderCrewsView: function() {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/crews', {
            trigger: false
        });
        if (this.crewsView == null) {
            this.crewsView = new PJQ.views.timecards.CrewsList({
                el: this.$('.crews-pane'),
                project: PJQ.app.session.project
            });
        }
    },
    renderEquipmentView: function() {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/equipment', {
            trigger: false
        });
        if (this.equipmentView == null) {
            this.equipmentView = new PJQ.views.timecards.EquipmentList({
                el: this.$('.equipment-pane'),
                project: PJQ.app.session.project
            });
        }
    },
    getActiveTab: function () {
        return this.$('.nav-item>.nav-link.active').attr('href');
    },
    settings: function () {
        switch (this.getActiveTab()) {
            case '#C_List':
                if (this.crewsView != null) {
                    this.crewsView.editSettings();
                }
                break;
            case '#E_List':
                if (this.equipmentView != null) {
                    this.equipmentView.editSettings();
                }
                break;
        }
    }
});
PJQ.views.timecards.EditCrewsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-edit-crew'),
        width: '800px'
    },
    events: {
        'click .btn-save': 'saveCrew',
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        if(!this.model){
            this.model = new PJQ.models.timecards.Crew({});
        }

        if(!this.model.isNew() && !this.model.isFetched){
            this.model.fetch({
                success: () => {
                    this.isFetched = true;
                    this.render()
                }
            })
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if(!this.isFetched)
            return;

        this.binder = new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            canEdit: true,
            setDefaultValues: true,
            inputs: {
                workers: {
                    contactSelector: {
                        context: PJQ.constants.contacts.contexts.USERS,
                        isSingleChoice: false,
                        canSwitchContext: true,
                        project: this.options.project,
                        disableContacts: _.map(
                            _.filter(this.model.workers.models, (model) => !model.get('delete') && model.person != null),
                            (model) => model.person
                        ),
                        selectedContact: _.map(
                            _.filter(this.model.workers.models, (model) => !model.get('delete') && model.person != null),
                            (model) => model.person
                        ),
                        setValue: function (value) {

                        },
                        onChange: (selectedContacts) => {
                            let selectedIds = new Set(_.map(selectedContacts, (contact) => contact.get('id')));

                            _.each(selectedContacts, (contact) => {
                                let existingWorker = this.model.workers.findWhere({ personId: contact.id });

                                if (existingWorker) {
                                    existingWorker.set('delete', false);
                                } else {
                                    let worker = new PJQ.models.timecards.CrewWorker({ personId: contact.get('id') })
                                    worker.person = contact;
                                    worker.set('person', contact.toJSON());
                                    this.model.workers.add(worker);
                                }
                            });

                            let workersToRemove = [];

                            this.model.workers.each((worker) => {
                                if (!worker) return;

                                if (!selectedIds.has(worker.get('personId'))) {
                                    if (worker.id > 0) {
                                        worker.set('delete', true);
                                    } else {
                                        workersToRemove.push(worker);
                                    }
                                }
                            });

                            this.model.workers.remove(workersToRemove);
                        }
                    }
                },
            }
        });
    },
    saveCrew: function () {
        const isNew = this.model.isNew();

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: `Crew ${ isNew ? 'Created' : 'Updated' } Successfully`,
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.removeModal();
            }
        });
    }
});
PJQ.views.timecards.CrewsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'crews-list')
    },
    events: {
        'click .add-crew': 'addCrew',
        'click .btn-edit-crew': 'editCrewClicked',
        'click .btn-delete-crew': 'deleteCrewClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.collection = this.options.project ? (await this.options.project.fetchCrews()) : (await PJQ.app.session.fetchCrews());
        this.isFetched = true;
        this.render()
    },
    renderData: function () {
        return {
            project: this.options.project
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".crews-list"),
            data: this.collection.models,
            order: [0, 'asc'],
            language: {
                zeroRecords: 'No Crews matched the search criteria',
                emptyRecords: 'Click "Add Crew" to create a new Crew'
            },
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'data-table-header-crews')
            },
            headerData: () => {
                return {
                    project: this.options.project
                }
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        isShown: (row) => {
                            return !this.options.project
                        },
                        onClick: (row) => {
                            this.editCrew(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return true;
                        },
                        onClick: (row) => {
                            this.deleteCrew(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "data": 'attributes.name',
                    "title": "Name",
                },
                {
                    "data": 'attributes.description',
                    "title": "Description",
                },
                {
                    "data": 'attributes.workersCount',
                    "title": "Total Workers",
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    'resizable': false,
                    "width": '90px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '';

                        if(!this.options.project) {
                            buttons += '<button type="button" class="btn btn-info btn-edit-crew wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
                        }
                        buttons += '<button type="button" class="btn btn-danger btn-delete-crew wd-30p"><i class="fal fa-trash"></i></button>';

                        return '<div class="show-on-row-hover text-align-right">' + buttons + '</div>'
                    }, this)
                }
            ],
            onRowDoubleClick: _.bind(function (row) {
                if(!this.options.project) {
                    this.editCrew(row.data());
                }
            }, this),
        });
    },
    addCrew: function () {
        if(!this.options.project) {
            this.editCrew();
        } else {
            new PJQ.views.timecards.SelectCrewsModal({
                selectedCrews: _.map(this.collection.models, (crew) => { return crew.id }),
                onSave: (crewIds, selectedCrews) => {
                    let existingIds = _.pluck(this.collection.models, 'id'),
                        newCrewIds = _.difference(crewIds, existingIds),
                        deleteCrewIds = _.difference(existingIds, crewIds);

                    this.collection.batchUpdate(newCrewIds, deleteCrewIds, (success, error) => {
                        if (success) {
                            const clonedCrews = _.map(selectedCrews, (model) => {
                                const attrs = model.toJSON();
                                return new PJQ.models.timecards.Crew(attrs, { projectId: this.options.project?.id });
                            });

                            this.collection.set(clonedCrews, { merge: true, remove: true });
                            this.dataTable.render();
                        }
                    });
                }
            });
        }
    },
    editCrewClicked: function (e){
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            crew = this.collection.get(cid);

        this.editCrew(crew);
    },
    editCrew: function (model) {
        new PJQ.views.timecards.EditCrewsModal({
            model: model,
            project: this.options.project,
            onSave: (crew) => {
                crew.set('workersCount', _.size(crew.workers.models));
                if(!model){
                    this.collection.add(crew);
                    this.dataTable.addRow(crew);
                } else {
                    this.dataTable.refresh();
                }
            }
        });
    },
    deleteCrewClicked: function(e) {
        let $row = $(e.currentTarget).closest('tr'),
            model = this.dataTable.getRow($row).data();

        this.deleteCrew(model);
    },
    deleteCrew: function (model) {
        new PJQ.views.modals.YesNo({
            header: "Delete Crew",
            body: "Do you want to delete this Crew?",
            onYes: _.bind(function () {
                model.destroy({
                    success: _.bind(function () {
                        this.collection.remove(model);
                        this.dataTable.render();
                    }, this)
                });
            }, this)
        });
    }
});

PJQ.views.timecards.SelectCrewsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'select-crews-modal'),
        minWidth: '800px'
    },
    events: {
        'click .select-crew': 'crewSelected',
        'click .btn-save': 'save',
        'click .select-all': 'selectAllClicked'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.selectedCrews = this.options.selectedCrews ?? [];

        this.collection = await PJQ.app.session.fetchCrews();
        this.isFetched = true;
        this.render()
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".crews-list"),
            data: this.collection.models,
            isHideSearch: true,
            order: [1, 'asc'],
            language: {
                zeroRecords: 'No crews available'
            },
            columns: [
                {
                    "data": "attributes.isSelected",
                    "title": `<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" ${_.size(this.options.selectedCrews) === _.size(this.collection.models) ? 'checked' : ''} class="select-all" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>`,
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let isSelected = _.contains(this.options.selectedCrews, row.id);

                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (isSelected ? 'checked' : '') + ' class="select-crew"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this)
                },
                {
                    "data": 'attributes.name',
                    "title": "Name"
                },
                {
                    "data": 'attributes.description',
                    "title": "Description"
                },
                {
                    "data": 'attributes.workersCount',
                    "title": "Total Workers"
                }
            ]
        });
    },
    selectAllClicked: function () {
        if(_.size(this.options.selectedCrews) === _.size(this.collection.models)) {
            this.options.selectedCrews = [];
            this.dataTable.refresh();
        } else {
            this.options.selectedCrews = _.map(this.collection.models, (model) => {
                return model.id;
            });
            this.dataTable.refresh();
        }
    },
    crewSelected: function(e) {
        let target = $(e.currentTarget),
            crew = this.dataTable.getRow(target.closest('tr')).data(),
            isSelected = _.contains(this.options.selectedCrews, crew.id);

        if(isSelected){
            this.options.selectedCrews = _.without(this.options.selectedCrews, crew.id);
        } else {
            this.options.selectedCrews.push(crew.id);
        }

        this.$('.select-all').attr('checked', _.size(this.options.selectedCrews) === _.size(this.collection.models));
    },
    save: function () {
        let selectedCrews = _.filter(this.collection.models, (crew) => {
           return _.contains(this.options.selectedCrews, crew.id);
        });

        if(typeof this.options.onSave === 'function') {
            this.options.onSave(this.options.selectedCrews, selectedCrews);
        }

        this.removeModal();
    }
});


PJQ.views.timecards.EditEquipmentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-edit-equipment'),
        width: '800px'
    },
    events: {
        'click .btn-save': 'saveEquipment',
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        if(!this.model){
            this.model = new PJQ.models.timecards.Equipment({});
        }
        this.isFetched = true;
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if(!this.isFetched)
            return;

        this.binder = new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            canEdit: true,
            setDefaultValues: true
        });
    },
    saveEquipment: function() {
        const isNew = this.model.isNew();

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: `Equipment ${ isNew ? 'Created' : 'Updated' } Successfully`,
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.removeModal();
            }
        });
    }
});
PJQ.views.timecards.EquipmentList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'equipment-list')
    },
    events: {
        'click .add-equipment': 'addEquipment',
        'click .btn-edit-equipment': 'editEquipmentClicked',
        'click .btn-delete-equipment': 'deleteEquipmentClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.collection = this.options.project ? (await this.options.project.fetchEquipment()) : (await PJQ.app.session.fetchEquipment());
        this.isFetched = true;
        this.render()
    },
    renderData: function () {
        return {
            project: this.options.project
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".equipment-list"),
            data: this.collection.models,
            order: [0, 'asc'],
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'data-table-header-equipment')
            },
            headerData: () => {
                return {
                    project: this.options.project
                }
            },
            language: {
                zeroRecords: 'No Equipment matched the search criteria',
                emptyRecords: 'Click "Add Equipment" to create a new Equipment',
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        isShown: (row) => {
                            return !this.options.project;
                        },
                        onClick: (row) => {
                            this.editEquipment(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return true;
                        },
                        onClick: (row) => {
                            this.deleteEquipment(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "columnData": "erpObject",
                    "data": null,
                    "title": "",
                    // "visible": visible,
                    "orderable": false,
                    "width": '50px',
                    "render": function (data, type, row) {
                        let exObj = row.get('externalObject');
                        if (exObj == null) {
                            return '';
                        }

                        if (type === 'sort' || type === 'type') {
                            return exObj.data?.externalNumber ?? "";
                        }
                        return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                    }
                },
                {
                    "data": 'attributes.name',
                    "title": "Name",
                    "render": (data, type, row) => {
                        if (type === 'sort' || type === 'type') {
                            return row.get('name');
                        }

                        return '<a class="btn-edit-equipment" href="javascript:void(0)" data-cid="' + row.cid + '">' + row.get('name') + '</a>';
                    }
                },
                {
                    "data": 'attributes.description',
                    "title": "Description"
                },
                {
                    "data": 'attributes.type',
                    "title": "Type"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '90px',
                    "resizable": false,
                    "render": _.bind(function (data, type, row) {
                        let buttons = '';

                        if(!this.options.project) {
                            buttons += '<button type="button" data-cid="' + row.cid + '" class="btn btn-info btn-edit-equipment wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
                        }
                        buttons += '<button type="button" class="btn btn-danger btn-delete-equipment wd-30p"><i class="fal fa-trash"></i></button>';

                        return '<div class="show-on-row-hover text-align-right">' + buttons + '</div>'
                    }, this)
                }
            ],
            onRowDoubleClick: _.bind(function (row) {
                if(!this.options.project) {
                    this.editEquipment(row.data());
                }
            }, this),
        });
    },
    addEquipment: function () {
        if(!this.options.project) {
            this.editEquipment();
        } else {
            new PJQ.views.timecards.SelectEquipmentModal({
                selectedEquipment: _.map(this.collection.models, (equipment) => { return equipment.id }),
                onSave: (equipmentIds, selectedEquipment) => {
                    let existingIds = _.pluck(this.collection.models, 'id'),
                        newEquipmentIds = _.difference(equipmentIds, existingIds),
                        deleteEquipmentIds = _.difference(existingIds, equipmentIds);

                    this.collection.batchUpdate(newEquipmentIds, deleteEquipmentIds, (success, error) => {
                        if (success) {
                            const clonedEquipment = _.map(selectedEquipment, (model) => {
                                const attrs = model.toJSON();
                                return new PJQ.models.timecards.Equipment(attrs, { projectId: this.options.project?.id });
                            });

                            this.collection.set(clonedEquipment, { merge: true, remove: true });
                            this.dataTable.render();
                        }
                    });

                }
            });
        }
    },
    editEquipmentClicked: function (e){
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            equipment = this.collection.get(cid);

        this.editEquipment(equipment);
    },
    editEquipment: function (model) {
        new PJQ.views.timecards.EditEquipmentModal({
            model: model,
            onSave: (equipment) => {
                if(!model){
                    this.collection.add(equipment);
                    this.dataTable.addRow(equipment);
                } else {
                    this.dataTable.refresh();
                }
            }
        });
    },
    deleteEquipmentClicked: function(e) {
        let $row = $(e.currentTarget).closest('tr'),
            model = this.dataTable.getRow($row).data();

        this.deleteEquipment(model);
    },
    deleteEquipment: function (model) {
        new PJQ.views.modals.YesNo({
            header: "Delete Equipment",
            body: "Do you want to delete this Equipment?",
            onYes: _.bind(function () {
                model.destroy({
                    success: _.bind(function () {
                        this.collection.remove(model);
                        this.dataTable.render();
                    }, this)
                });
            }, this)
        });
    }
});

PJQ.views.timecards.SelectEquipmentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'select-equipment-modal'),
        minWidth: '800px'
    },
    events: {
        'click .select-equipment': 'equipmentSelected',
        'click .btn-save': 'save',
        'click .select-all': 'selectAllClicked'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.selectedEquipment = this.options.selectedEquipment ?? [];

        this.collection = await PJQ.app.session.fetchEquipment();
        this.isFetched = true;
        this.render()
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".equipment-list"),
            data: this.collection.models,
            isHideSearch: true,
            order: [1, 'asc'],
            language: {
                zeroRecords: 'No equipment available'
            },
            columns: [
                {
                    "data": "attributes.isSelected",
                    "title": `<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" ${_.size(this.options.selectedEquipment) === _.size(this.collection.models) ? 'checked' : ''} class="select-all" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>`,
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let isSelected = _.contains(this.options.selectedEquipment, row.id);

                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (isSelected ? 'checked' : '') + ' class="select-equipment"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this)
                },
                {
                    "data": 'attributes.name',
                    "title": "Name",
                    "orderable": false
                },
                {
                    "data": 'attributes.description',
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": 'attributes.type',
                    "title": "Type",
                    "orderable": false
                }
            ]
        });
    },
    selectAllClicked: function () {
        if(_.size(this.options.selectedEquipment) === _.size(this.collection.models)) {
            this.options.selectedEquipment = [];
            this.dataTable.refresh();
        } else {
            this.options.selectedEquipment = _.map(this.collection.models, (model) => {
                return model.id;
            });
            this.dataTable.refresh();
        }
    },
    equipmentSelected: function(e) {
        let target = $(e.currentTarget),
            equipment = this.dataTable.getRow(target.closest('tr')).data(),
            isSelected = _.contains(this.options.selectedEquipment, equipment.id);

        if(isSelected){
            this.options.selectedEquipment = _.without(this.options.selectedEquipment, equipment.id);
        } else {
            this.options.selectedEquipment.push(equipment.id);
        }

        this.$('.select-all').attr('checked', _.size(this.options.selectedEquipment) === _.size(this.collection.models));
    },
    save: function () {
        let selectedEquipment = _.filter(this.collection.models, (equipment) => {
            return _.contains(this.options.selectedEquipment, equipment.id);
        });

        if(typeof this.options.onSave === 'function') {
            this.options.onSave(this.options.selectedEquipment, selectedEquipment);
        }

        this.removeModal();
    }
});
PJQ.views.timecards.LineItemsView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-line-items'),
        onLineItemChanged: null,
        canEdit: true
    },
    events: {
        'keyup .li-overtime-hours, .li-regular-hours, .li-doubletime-hours': 'lineItemHoursChanged',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-delete-line-item': 'deleteLineItem',
        'click .btn-view-li-locations': 'viewTimecardLocationsClicked'
    },
    beforeFirstRender: function () {
        this.model = this.options.model;
        this.contact = null;

        let fnFetch = () => {
            if (this.options.project != null) {
                this.options.project.fetchPermissions((perms) => {
                    this.options.permissions = perms;
                    if (this.options.settings.get('enableLineItems')) {
                        this.options.project.fetchSubJobs((subJobs) => {
                            this.subJobs = subJobs;
                            this.options.project.fetchCostCodes((costCodes) => {
                                this.costCodes = costCodes;
                                this.isFetched = true;
                                this.render();
                            });
                        });
                    } else {
                        this.isFetched = true;
                        this.render();
                    }
                });
            } else {
                this.options.permissions = PJQ.app.session.systemPermissions;
                this.isFetched = true;
            }
        };
        this.isFetched = false;
        fnFetch();
    },
    beforeRender: function () {
        if (this.isFetched) {
            this.options.canEdit = this.model.get('approvedOn') == null && this.options.permissions.hasPermission('timeCards.canAdd');
            this.options.enableOvertime = this.options.settings.get('enableOvertime');
            this.options.enableDoubletime = this.options.settings.get('enableDoubletime');
            this.options.enableClockIn = this.options.settings.get('enableClockIn')
        }
    },
    renderData: function () {
        return {
            model: this.model,
            contact: this.contact,
            project: this.options.project,
            canEdit: this.options.canEdit,
            enableOvertime: this.options.enableOvertime,
            enableDoubletime: this.options.enableDoubletime
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderLineItems();
    },
    renderLineItems: function () {
        if (this.options.canEdit && _.size(this.model.lineItems.models) === 0) {
            this.model.lineItems.add(this.newLineItem());
        }

        let columns = [
            {
                "title": "#",
                "width": "50px",
                "render": _.bind(function (data, type, row, opt) {
                    let icons = '';
                    if ((row.get('latitudeIn') && row.get('longitudeIn')) || (row.get('latitudeOut') && row.get('longitudeOut'))) {
                        icons += '<button type="button" title="View Time Card Locations" class="btn btn-link btn-view-li-locations fs-16 ml-1"><i class="fal fa-location-dot"></i></button>'
                    }
                    return '<div class=" text-align-center ' + (this.options.canEdit ? '' : 'p-1') + '">' + (opt.row + 1).toString() + icons + '</div>';
                }, this)
            },
            {
                "title": "Sub Job",
                "width": "150px",
                "visible": this.subJobs != null && _.size(this.subJobs.models) > 0,
                "render": (data, type, row) => {
                    if (this.options.canEdit && row.isNew()) {
                        return '<select class="select-sub-job form-control"></select>';
                    }

                    let costCode = this.costCodes.get(row.get('costCodeId')),
                        subJob = this.subJobs.get(costCode.get('subJobId'));
                    return subJob ? subJob.get('name') : '';
                }
            },
            {
                "title": "Cost Code",
                "width": "250px",
                "render": (data, type, row) => {
                    if (this.options.canEdit && row.isNew()) {
                        return '<select class="select-cost-code form-control"></select>';
                    }

                    let costCode = this.costCodes.get(row.get('costCodeId'));
                    return costCode ? costCode.getDisplayName() : '';
                }
            }];

        if (this.options.enableClockIn) {
            columns.push(...[{
                "data": "attributes.timeIn",
                "width": "150px",
                "title": "Time In",
                "orderable": false,
                "searchable": false,
                "className": "text-align-center",
                "render": _.bind(function (data, type, row) {
                    let time = '';
                    if (data != null) {
                        time = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME)
                    }
                    if (this.options.canEdit) {
                        return '<div class="position-relative input-group"><input type="text" class="form-control input-time li-time-in" data-cid="' + row.cid +'" placeholder="12:00 AM" value="' + time + '"></div>';
                    }
                    return time;
                }, this),
            },
                {
                    "data": "attributes.timeOut",
                    "width": "150px",
                    "title": "Time Out",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let time = '';
                        if (data != null) {
                            time = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME)
                        }
                        if (this.options.canEdit) {
                            return '<div class="position-relative input-group"><input type="text" class="form-control input-time li-time-out" data-cid="' + row.cid +'" placeholder="12:00 AM" value="' + time + '"></div>';
                        }
                        return time;
                    }, this),
                }]);
        } else {
            columns.push(...[
                {
                    "data": "attributes.regularHours",
                    "width": "120px",
                    "title": this.options.enableOvertime || this.options.enableDoubletime ? "Regular" : "Hours",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let hrs = PJQ.helpers.formatHelpers.minutesToHHMM(row.get('regularHours'));
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours li-regular-hours" value="' + hrs + '" data-type="regularHours" placeholder="00:00">';
                        }
                        return hrs;
                    }, this),
                },
                {
                    "data": "attributes.overtimeHours",
                    "width": "120px",
                    "title": "Overtime",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "visible": this.options.enableOvertime === true,
                    "render": _.bind(function (data, type, row) {
                        let hrs = PJQ.helpers.formatHelpers.minutesToHHMM(row.get('overtimeHours'));
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours li-overtime-hours" value="' + hrs + '" data-type="overtimeHours" placeholder="00:00">';
                        }
                        return hrs;
                    }, this),
                },
                {
                    "data": "attributes.doubletimeHours",
                    "width": "120px",
                    "title": "Double Time",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "visible": this.options.enableDoubletime === true,
                    "render": _.bind(function (data, type, row) {
                        let hrs = PJQ.helpers.formatHelpers.minutesToHHMM(row.get('doubletimeHours'));
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours li-doubletime-hours" value="' + hrs + '" data-type="doubletimeHours" placeholder="00:00">';
                        }
                        return hrs;
                    }, this),
                }]);
        }

        if (this.options.canEdit) {
            columns.push({
                data: "id",
                title: "",
                orderable: false,
                searchable: false,
                width: 50,
                className: 'text-align-center',
                render: _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-danger btn-delete-line-item ml-1"><i class="fal fa-trash"></i></button></div>';
                }, this)
            });
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.line-items-table'),
            data: _.filter(this.model.lineItems.models, function (lineItem) {
                return !lineItem.get('delete');
            }),
            autoWidth: false,
            fixedHeader: {
                header: false,
                footer: false
            },
            isHideSearch: true,
            paging: false,
            order: [1, 'asc'],
            language: {
                emptyTable: this.options.canEdit ? 'Click "Add Line Item" to create a new Line item' : 'No line items have been added yet'
            },
            columns: columns,
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
            }, this),
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteLineItem(row);
                        }, this),
                        isShown: _.bind(function (row) {
                            this.options.canEdit
                        }, this),
                    }
                ]
            },
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskHours(this.$('.input-hours'));

        if (this.options.canEdit) {
            this.addListeners();
            if (!this.binder) {
                this.binder = new PJQ.Binder(this.$el, this.model.lineItems, {
                    delegate: true,
                    useDecimalPercentFields: true,
                    watchElements: [
                        'input'
                    ]
                });
            }

            _.each(this.model.lineItems.models, function(model){
                model.timeInPicker = new PJQ.inputs.Datepicker({
                    el: this.$('.li-time-in[data-cid="' + model.cid + '"]'),
                    isTimeOnly: true,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                        defaultDate: model.get('timeIn')
                    },
                    onChange: (value) => {
                        model.set('timeIn', value);
                    }
                });

                model.timeOutPicker = new PJQ.inputs.Datepicker({
                    el: this.$('.li-time-out[data-cid="' + model.cid + '"]'),
                    isTimeOnly: true,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                        defaultDate: model.get('timeOut')
                    },
                    onChange: (value) => {
                        model.set('timeOut', value);
                    }
                });
            }, this)


            if (this.subJobs != null && _.size(this.subJobs.models) > 0) {
                new PJQ.inputs.SelectPickerCollection(this.$el, this.model.lineItems.models, {
                    pickerSelector: '.select-sub-job',
                    valueAttribute: 'subJobId',
                    selectPickerOptions: {
                        noneSelectedText: 'Parent Job',
                        isLiveSearch: true,
                        isIntChoices: true,
                        size: 8,
                        isDisabled: _.bind(function (model) {
                            return !model.isNew() || !this.options.canEdit;
                        }, this),
                        choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                            name: 'Sub Jobs', choices: _.map(this.subJobs.models, function (subJob) {
                                return {
                                    id: subJob.id,
                                    name: subJob.get('code'),
                                    subtext: subJob.get('name')
                                }
                            }, this)
                        }])
                    },
                    onChange: _.bind(function (model, value) {
                        model.set('subJobId', value > 0 ? value : null);
                        model.set('costCodeId', null);

                        let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid];
                        costCodePicker.render();
                    }, this)
                });
            }

            this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.model.lineItems.models, {
                pickerSelector: '.select-cost-code',
                valueAttribute: 'costCodeId',
                selectPickerOptions: {
                    isLiveSearch: true,
                    isIntChoices: true,
                    hideDisabled: false,
                    isDisabled: _.bind(function (model) {
                        return !model.isNew() || !this.options.canEdit;
                    }, this),
                    choices: (model) => {
                        let sjId = model.get('subJobId');
                        return _.map(_.filter(this.costCodes.models, (costCode) => {
                            return (sjId == null && costCode.get('subJobId') == null) || costCode.get('subJobId') === sjId;
                        }).sort((c1, c2) => {
                            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
                        }), function (costCode) {
                            return {
                                id: costCode.id,
                                name: costCode.getDisplayName()
                            };
                        });
                    }
                },
                onChange: _.bind(function (model, value) {
                    model.set('costCodeId', value);
                }, this)
            });
        }
    },
    addListeners: function () {
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'change', (lineItem) => {
            let lineItems = _.filter(this.model.lineItems.models, (lineItem) => {
                return !lineItem.get('delete');
            })
            this.model.set({
                regularHours: _.reduce(lineItems, function (mem, li) {
                    return mem + li.get('regularHours');
                }, 0),
                overtimeHours: _.reduce(lineItems, function (mem, li) {
                    return mem + li.get('overtimeHours');
                }, 0),
                doubletimeHours: _.reduce(lineItems, function (mem, li) {
                    return mem + li.get('doubletimeHours');
                }, 0)
            });
            if (typeof this.options.onLineItemChanged === 'function') {
                this.options.onLineItemChanged(lineItem);
            }
        });
    },
    getLineItemForInput: function ($input) {
        if ($input == null || this.dataTable == null) {
            return null;
        }
        let row = this.dataTable.getRow($input.closest('tr'));
        if (row) {
            return row.data();
        }
        return null;
    },
    getLineItemElement: function (lineItem) {
        if (lineItem == null || this.dataTable == null) {
            return null;
        }
        let row = this.dataTable.getRow(lineItem.cid);
        if (row) {
            return $(row.node());
        }
        return null;
    },
    lineItemHoursChanged: function (e) {
        let lineItem = this.getLineItemForInput($(e.currentTarget)),
            type = $(e.currentTarget).data('type'),
            minutes = PJQ.helpers.formatHelpers.minutesFromHHMM($(e.currentTarget).val());
        lineItem.set(type, minutes);
    },
    addLineItem: function (e) {
        this.model.lineItems.add(this.newLineItem());
        this.renderLineItems();
    },
    newLineItem: function () {
        return new PJQ.models.timecards.TimeCardLineItem({
            timeCardId: this.model.id,
            notes: '',
            regularHours: 0,
            overtimeHours: 0,
            doubletimeHours: 0
        });
    },
    deleteLineItem: function (e) {
        let lineItem = this.getLineItemForInput($(e.currentTarget));
        if (lineItem) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this Line Item?",
                onDelete: _.bind(function () {
                    lineItem.set('delete', true);
                    this.renderLineItems();
                }, this)
            });
        }
    },
    viewTimecardLocationsClicked: function (e) {
        let target = $(e.currentTarget),
            lineItem = this.dataTable.getRow(target.closest('tr')).data();

        this.viewTimecardLocations(lineItem);
    },
    viewTimecardLocations: function (lineItem) {
        new PJQ.views.timecards.TimeCardLocationMapModal({
            model: lineItem
        });
    }
});
PJQ.views.timecards.AddTimeCardsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-manage-timecards'),
        subTemplates: {
            timecard: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'contact-timecard')
        },
        minWidth: '1000px',
        timeCard: null,
        project: null,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .timecard-delete': 'deleteTimeCard',
        'click .timecards-save': 'saveTimeCards',
        'click .timecards-save-add-pq': 'saveAndAddQuantities',
        'click .timecards-continue': 'nextStep',
        'click .timecards-previous': 'previousStep',
        'click .timecards-close': 'closeAddTimeCards',
        'keyup .overtime-time, .regular-time, .doubletime-time': 'hoursChanged',
        'keyup .time-in, .time-out': 'lineItemClockChanged',
        'click .btn-bulk-entry': 'bulkEntry'
    },
    beforeModalCreated: function () {
        this.collection = new PJQ.collections.timecards.TimeCards();
        this.options.step = PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE;

        this.options.enableLineItems = this.options.settings.get('enableLineItems');

        if (this.options.project != null) {
            this.options.permissions = this.options.project.permissions ? this.options.project.permissions : PJQ.app.session.project.permissions;
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;
        }

        this.options.isAdmin = this.options.permissions.hasPermission('timeCards.isAdmin');
        this.options.canAddQuantities = this.options.permissions.hasPermission('productionQuantities.canAdd');
        if (!this.options.isAdmin) {
            this.options.contact = new PJQ.models.projectContacts.ProjectContact(PJQ.app.session.user.toJSON());
        }

        let dateNow = new Date();
        this.options.timeCardDate = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
        this.options.stepTotal = 4;
        if (this.options.timeCard != null) {
            this.options.project = this.options.project ? this.options.project : this.options.timeCard.get('project');
            this.collection.add(this.options.timeCard);
            this.options.timeCardDate = PJQ.helpers.dateHelpers.parseDateString(this.options.timeCard.get('date'), false);
            this.options.step = PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS;
        } else if (this.options.project != null) {
            this.options.stepTotal -= 1;
            this.options.step = PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE;
        }

        if (!this.options.isAdmin) {
            this.options.stepTotal -= 1;
        }
    },
    beforeRender: function () {
        this.options.enableOvertime = this.options.settings.get('enableOvertime');
        this.options.enableDoubletime = this.options.settings.get('enableDoubletime');
        this.options.enableLineItems = this.options.settings.get('enableLineItems');
        this.options.enableClockIn = this.options.settings.get('enableClockIn');
    },
    renderData: function () {
        return {
            project: this.selectedProject,
            date: this.options.timeCardDate,
            settings: this.options.settings,
            stepTotal: this.options.stepTotal,
            step: this.options.step,
            enableOvertime: this.options.enableOvertime,
            enableDoubletime: this.options.enableDoubletime,
            enableLineItems: this.options.enableLineItems,
            enableClockIn: this.options.enableClockIn,
            canAddQuantities: this.options.canAddQuantities,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        this.renderStep();
    },
    hoursChanged: function (e) {
        let $target = $(e.currentTarget).closest('.contact-timecard'),
            cid = $target.data('cid'),
            timecard = this.collection.get(cid),
            type = $(e.currentTarget).data('type'),
            minutes = PJQ.helpers.formatHelpers.minutesFromHHMM($(e.currentTarget).val());
        timecard.set(type, minutes);
    },
    renderStep: async function () {
        switch (this.options.step) {
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE:
                this.selectedItems = {};
                this.timeCardDatePicker = new PJQ.inputs.Datepicker({
                    el: this.$('.timecard-date'),
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                        defaultDate: this.options.timeCardDate,
                    }
                });
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT:
                this.selectedItems = {};
                new PJQ.views.projects.ProjectSelector({
                    el: this.$('.select-project'),
                    isSingleChoice: true,
                    onProjectSelected: _.bind(function (project) {
                        this.selectedProject = project;
                        if (project !== null) {
                            this.$('.timecards-continue').prop('disabled', (this.selectedProject === null));
                        } else {
                            this.$('.timecards-continue').prop('disabled', true);
                        }
                    }, this),
                    dataTableHeaderData: {
                        isHideDeletedFilter: true
                    }
                });
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS:
                this.timeCardItemsPicker = new PJQ.views.timecards.SelectTimeCardsToCreate({
                    el: this.$('.select-contacts'),
                    project: this.selectedProject
                });
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS:
                let fnTc = () => {
                    let timecards = new PJQ.collections.timecards.TimeCards(),
                        dateNow = new Date(),
                        parameters = {
                            searchFor: '',
                            idFilter: (() => {
                                let people = this.selectedItems.people;
                                let equipment = this.selectedItems.equipment;

                                if (_.size(people) === 1 && _.isEmpty(equipment)) {
                                    return people[0].id;
                                }

                                if (_.size(equipment) === 1 && _.isEmpty(people)) {
                                    return equipment[0].id;
                                }

                                return _.uniq(
                                    _.map(people, p => p.id).concat(_.map(equipment, e => e.id))
                                );
                            })(),
                            startDate: PJQ.helpers.dateHelpers.getDateString(this.options.timeCardDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                            endDate: PJQ.helpers.dateHelpers.getDateString(this.options.timeCardDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                            page: 1,
                            pageSize: 2147483646,
                            orderBy: 'companyName',
                            orderDirection: 'asc',
                            projectId: this.selectedProject.get('projectId'),
                            timeZoneOffset: dateNow.getTimezoneOffset()
                        };

                    timecards.fetch({
                        data: parameters,
                        success: () => {
                            _.each(timecards.models, timecard => {
                                let equipmentId = timecard.get('equipmentId');
                                let contactId = timecard.get('contact')?.id;
                                let isEquipment = equipmentId != null && equipmentId > 0;

                                let contactSelected = _.find(this.selectedItems.people, contact => contact.id === contactId);
                                let equipmentSelected = _.find(this.selectedItems.equipment, equipment => equipment.id === equipmentId);

                                let alreadyExists = this.collection.getTimeCard(timecard.get('id'), timecard.get('date'), isEquipment);

                                if (!alreadyExists && (contactSelected || equipmentSelected)) {
                                    this.collection.add(timecard);
                                }
                            });

                            let date = this.options.timeCardDate
                            _.each(this.selectedItems.people, (contact) => {
                                if (this.collection.getTimeCard(contact.get('personId') ?? contact.get('id'), date))
                                    return;

                                if (contact.get('contactId') == null)
                                    contact.set('contactId', 0);

                                let timeCard = new PJQ.models.timecards.TimeCard({
                                    projectId: this.selectedProject.get('projectId'),
                                    id: contact.get('personId') ?? contact.get('id'),
                                    date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
                                    notes: '',
                                    regularHours: 0,
                                    overtimeHours: 0,
                                    doubletimeHours: 0,
                                    createdBy: -PJQ.app.session.user.id,
                                    contact: contact.attributes.person ?? contact.attributes
                                });
                                this.collection.add(timeCard);
                            });

                            _.each(this.selectedItems.equipment, (equipment) => {
                                if (this.collection.getTimeCard(equipment.get('id'), date, true))
                                    return;

                                let timeCard = new PJQ.models.timecards.TimeCard({
                                    projectId: this.selectedProject.get('projectId'),
                                    id: 0,
                                    equipmentId: equipment.get('id'),
                                    date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
                                    notes: '',
                                    regularHours: 0,
                                    overtimeHours: 0,
                                    doubletimeHours: 0,
                                    createdBy: -PJQ.app.session.user.id,
                                    equipment: equipment.attributes
                                });
                                this.collection.add(timeCard);
                            });

                            let $tcOuter = this.$('.timecard-data');
                            $tcOuter.empty();
                            _.each(this.collection.models, function (model) {
                                if (!model.get('deletedOn')) {
                                    this.renderSubTemplate(true, this.options.subTemplates.timecard, $tcOuter, {
                                        timecard: model,
                                        timecards: this.collection.models,
                                        item: model.get('contact') ?? model.get('equipment'),
                                        settings: this.options.settings,
                                        enableOvertime: this.options.enableOvertime,
                                        enableDoubletime: this.options.enableDoubletime,
                                        enableLineItems: this.options.enableLineItems,
                                        enableClockIn: this.options.enableClockIn,
                                        canEdit: this.options.canEdit,
                                        isAdmin: this.options.isAdmin
                                    }, _.bind(function (el) {
                                        new PJQ.Binder(el, model, {
                                            watchElements: [
                                                'textarea'
                                            ]
                                        });
                                        let fnTotal = () => {
                                            let regularHours = PJQ.helpers.formatHelpers.minutesToHHMM(model.get('regularHours')),
                                                overtimeHours = PJQ.helpers.formatHelpers.minutesToHHMM(model.get('overtimeHours')),
                                                doubletimeHours = PJQ.helpers.formatHelpers.minutesToHHMM(model.get('doubletimeHours'));

                                            if (this.options.enableClockIn) {
                                                let minutes = 0;
                                                if (this.options.enableLineItems) {
                                                    _.each(model.lineItems.models, function (lineItem) {
                                                        if (lineItem.get('timeIn') != null && lineItem.get('timeOut') != null) {
                                                            minutes += PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(lineItem.get('timeOut')), new Date(lineItem.get('timeIn')));
                                                        }
                                                    });
                                                } else if (model.get('timeIn') != null && model.get('timeOut') != null) {
                                                    minutes = PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(model.get('timeOut')), new Date(model.get('timeIn')));
                                                }

                                                regularHours = minutes > 0 ? PJQ.helpers.formatHelpers.minutesToHHMM(minutes) : '00:00'
                                            }

                                            el.find('.label-regular-hours').text(regularHours);
                                            el.find('.label-overtime-hours').text(overtimeHours);
                                            el.find('.label-doubletime-hours').text(doubletimeHours);
                                            el.find('.regular-hours').val(regularHours);
                                            el.find('.overtime-hours').val(overtimeHours);
                                            el.find('.doubletime-hours').val(doubletimeHours);
                                        };
                                        fnTotal();

                                        if (this.options.enableLineItems) {
                                            new PJQ.views.timecards.LineItemsView({
                                                el: el.find('.line-items-outer'),
                                                model: model,
                                                project: this.selectedProject,
                                                settings: this.options.settings,
                                                onLineItemChanged: () => {
                                                    fnTotal();
                                                }
                                            });
                                        } else {
                                            new PJQ.inputs.Datepicker({
                                                el: this.$('.time-in[data-cid="' + model.cid + '"]'),
                                                isTimeOnly: true,
                                                datepickerOptions: {
                                                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                                                    defaultDate: model.get('timeIn')
                                                },
                                                onChange: (value) => {
                                                    model.set('timeIn', value);
                                                    fnTotal();
                                                }
                                            });

                                            new PJQ.inputs.Datepicker({
                                                el: this.$('.time-out[data-cid="' + model.cid + '"]'),
                                                isTimeOnly: true,
                                                datepickerOptions: {
                                                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                                                    defaultDate: model.get('timeOut')
                                                },
                                                onChange: (value) => {
                                                    model.set('timeOut', value);
                                                    fnTotal();
                                                }
                                            });
                                        }
                                    }, this));
                                }
                            }, this);
                            PJQ.helpers.inputHelpers.inputMaskHours(this.$('.input-hours'));
                        }
                    });
                };
                this.selectedProject.fetchPermissions((perms) => {
                    this.options.permissions = perms;
                    if (this.options.enableLineItems) {
                        this.selectedProject.fetchSubJobs((subJobs) => {
                            this.subJobs = subJobs;
                            this.selectedProject.fetchCostCodes((costCodes) => {
                                this.costCodes = costCodes;
                                fnTc();
                            });
                        });
                    } else {
                        fnTc();
                    }
                });
                break;
        }
    },
    setStep: function (step) {
        this.options.step = step;
        this.render();
    },
    nextStep: function () {
        switch (this.options.step) {
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE:
                this.options.timeCardDate = this.timeCardDatePicker.getValue();

                if (this.options.project != null && this.options.contact != null) {
                    this.selectedProject = this.options.project;
                    this.selectedItems = {people: [this.options.contact]};
                    this.setStep(PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS);
                } else if (this.options.project != null) {
                    this.selectedProject = this.options.project;
                    this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS);
                } else {
                    this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT);
                }
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT:
                let fnNextStep = () => {
                    if (this.options.contact != null) {
                        this.selectedItems = {people: [this.options.contact]};
                        this.setStep(PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS);
                    } else {
                        this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS);
                    }
                }
                if (this.options.project != null && this.selectedProject.get('projectId') !== this.options.project.get('projectId')) {
                    if (this.selectedProject.get('projectId') !== this.options.project.get('projectId')) {
                        new PJQ.views.modals.YesNo({
                            header: "Confirm Project Change",
                            body: "Are you sure you want to change the Project?  Doing so will clear any data you have entered without saving.",
                            onYes: _.bind(function () {
                                this.options.project = this.selectedProject;
                                fnNextStep();
                            }, this)
                        });
                    } else {
                        fnNextStep();
                    }
                } else {
                    fnNextStep();
                }
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS:
                this.selectedItems = this.timeCardItemsPicker.getSelectedItems();
                this.setStep(PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS);
                break;
        }
    },
    previousStep: function () {
        switch (this.options.step) {
            case PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS:
                this.setStep(this.options.contact != null ? PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT : PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS);
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS:
                this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT);
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT:
                this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE);
                break;
        }
    },
    addLineItem: function (e) {
        let $target = $(e.currentTarget).closest('.contact-timecard'),
            cid = $target.data('cid'),
            timecard = this.collection.get(cid),
            lineItem = new PJQ.models.timecards.TimeCardLineItem({
                timeCardId: timecard.id,
                notes: ''
            });

        timecard.lineItems.add(lineItem);
        this.render();
    },
    deleteTimeCard: function (e) {
        let $target = $(e.currentTarget).closest('.contact-timecard'),
            cid = $target.data('cid'),
            timecard = this.collection.get(cid);

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Time Card?",
            onDelete: _.bind(function () {
                this.collection.remove(timecard);

                if (timecard.get('equipmentId') != null && timecard.get('equipmentId') > 0) {
                    this.selectedItems.equipment = _.filter(this.selectedItems.equipment, item => {
                        return item.id !== timecard.get('id');
                    });
                } else {
                    this.selectedItems.people = _.filter(this.selectedItems.people, item => {
                        return item.id !== timecard.get('id');
                    });
                }

                this.render();
            }, this)
        });
    },
    deleteLineItem: function (e) {
        let $timecard = $(e.currentTarget).closest('.contact-timecard'),
            $lineItem = $(e.currentTarget).closest('.timecard-line-item'),
            timecard = this.collection.get($timecard.data('cid'));

        if (timecard) {
            let lineItem = timecard.lineItems.get($lineItem.data('cid'));

            if (lineItem) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Confirm Deletion",
                    body: "Are you sure you want to delete this Line Item?",
                    onDelete: _.bind(function () {
                        lineItem.set('delete', true);
                        timecard.set({
                            regularHours: timecard.get('regularHours') - lineItem.get('regularHours'),
                            overtimeHours: timecard.get('overtimeHours') - lineItem.get('overtimeHours'),
                            doubletimeHours: timecard.get('doubletimeHours') - lineItem.get('doubletimeHours')
                        });
                        this.render();
                    }, this)
                });
            }
        }
    },
    bulkEntry: function () {
        let timeCard = new PJQ.models.timecards.TimeCard({
            projectId: this.selectedProject.get('projectId'),
            id: 0,
            date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(this.options.timeCardDate, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
            notes: '',
            regularHours: 0,
            overtimeHours: 0,
            doubletimeHours: 0,
            createdBy: -PJQ.app.session.user.id,
            contact: null
        });

        new PJQ.views.timecards.BulkEntryModal({
            project: this.selectedProject,
            settings: this.options.settings,
            model: timeCard,
            timeCards: this.collection,
            onSave: () => {
                this.render();
            }
        });
    },
    saveAndAddQuantities: function () {
        this.saveTimeCards(null, true);
    },
    addQuantities: function () {
        new PJQ.views.productionQuantities.TimeCardQuantitiesAddModal({
            project: this.selectedProject,
            timeCards: this.collection
        });
    },
    saveTimeCards: function (e, isAddQuantities) {
        if (_.size(this.collection.models) === 0)
            return;

        let isValid = true,
            isLineItemsValid = true,
            invalidCount = 0,
            fnSave = _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'timecards',
                        },
                        {
                            endpoint: 'batch'
                        }
                    ]),
                    data: {
                        rows: this.collection.models
                    },
                    isAPIv2: true
                }).post().success(_.bind(function (data) {
                    this.collection.reset(data.rows);
                    PJQ.notifications.notify.successNotify({
                        message: 'Time Cards saved successfully'
                    });
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave();
                    }
                    this.removeModal();

                    if (isAddQuantities) {
                        this.addQuantities();
                    }
                }, this));
            }, this);

        _.each(this.collection.models, _.bind(function (model) {
            if (!model.get('deletedOn') && (model.get('regularHours') + model.get('overtimeHours') + model.get('doubletimeHours') === 0) && !this.options.enableClockIn) {
                isValid = false;
                invalidCount++;
            } else if (this.options.enableClockIn && !this.options.enableLineItems && (model.get('timeIn') == null || model.get('timeOut') == null)) {
                isValid = false;
                invalidCount++
            } else if (this.options.enableLineItems && this.options.enableClockIn) {
                _.each(model.lineItems.models, _.bind(function (lineItem) {
                    if (!lineItem.get('delete') && (lineItem.get('timeIn') == null || lineItem.get('timeOut') == null || lineItem.get('costCodeId') == null)) {
                        isLineItemsValid = false;
                    }
                }, this));
            }

            // Validate and set line items
            if (this.options.enableLineItems) {
                model.set('lineItems', model.lineItems.toJSON());
            }
        }, this));

        if (!isValid && isLineItemsValid) {
            new PJQ.views.modals.YesNo({
                header: "Time Entry Warning",
                body: invalidCount.toString() + " Time Card" + (invalidCount > 1 ? "s do" : " does") + " not have time entered.  Do you want to save anyway?",
                onYes: _.bind(function () {
                    fnSave();
                }, this)
            });
        } else if (isLineItemsValid) {
            fnSave();
        }
    },
    closeAddTimeCards: function () {
        if (this.options.step === PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS) {
            new PJQ.views.modals.YesNo({
                header: "Unsaved Time Cards",
                body: "Unsaved Time Cards will be lost.  Are you sure you want to close without saving?",
                onYes: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.timecards.SelectTimeCardsToCreate = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'select-timecards-to-create')
    },
    events: {
        'keyup .input-search': 'search',
        'click .time-card-selection-option': 'selectionOptionClicked',
        'click .input-select-option': 'optionSelected',
        'click .btn-remove-selected-item': 'removeSelectedItem',
        'click .btn-select-all': 'selectAll',
        'click .btn-remove-all': 'removeAll'
    },
    beforeFirstRender: async function () {
        let loader = new PJQ.Loader(this.$el);
        this.isFetched = false;

        this.crews = await this.options.project.fetchCrews();
        this.equipment = await this.options.project.fetchEquipment();

        this.options.project.fetchProjectContacts((projectContacts) => {
            this.projectContacts = projectContacts;
            this.selectionOptionName = "All Project Contacts";
            this.selectionOption = "allProjectContacts"
            this.selection = projectContacts;
            this.selectedItemIds = {};

            this.isFetched = true;
            loader.remove();
            this.render();
        });
    },
    beforeRender: function () {
        if (!this.isFetched)
            return;
    },
    renderData: function () {
        return {
            model: this.model,
            crews: this.crews?.models,
            equipment: this.equipment?.models,
            projectContacts: this.projectContacts?.models,
            selectionOptionName: this.selectionOptionName,
            selectionOption: this.selectionOption,
            selection: this.selection,
            selectedItemIds: this.selectedItemIds,
            isFetched: this.isFetched,
            search: this.options.search
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.search();
    },
    selectionOptionClicked: function (e) {
        let $target = $(e.currentTarget),
            type = $target.data('type'),
            currentSelection = this.$('.selected-time-card-option');

        if (currentSelection === $target || type == null)
            return;

        switch (type.toLowerCase()) {
            case 'allprojectcontacts':
                this.selectionOptionName = 'All Project Contacts';
                this.selectionOption = type;
                this.selection = this.projectContacts;
                break;
            case 'equipment':
                this.selectionOptionName = 'Equipment';
                this.selectionOption = type;
                this.selection = this.equipment;
                break;
            case 'crew':
                let cid = $target.data('cid'),
                    crew = this.crews.get(cid);
                this.selectionOptionName = crew.get('name');
                this.selectionOption = crew.cid;
                this.selection = crew.workers;
                break;
        }
        this.filteredSelection = [];

        this.render();
    },
    search: function (e) {
        if (e != null) {
            this.options.search = $(e.currentTarget).val().toLowerCase();
        }

        if (_.size(this.options.search) === 0) {
            this.options.search = "";
            this.filteredSelection = null;
        } else {
            this.filteredSelection = [];
        }

        let hasMatch = false;
        _.each(this.selection.models, (model) => {
            let $sel = this.$('.input-select-option[data-cid="' + model.cid + '"]').closest('.select-option'),
                match = false;
            switch (this.selectionOption.toLowerCase()) {
                case 'allprojectcontacts':
                    match = (model.get('contactName') ?? "").toLowerCase().indexOf(this.options.search) > -1
                        || (model.get('companyName') ?? "").toLowerCase().indexOf(this.options.search) > -1;
                    break;
                case 'equipment':
                    match = (model.get('name') ?? "").toLowerCase().indexOf(this.options.search) > -1
                        || (model.get('description') ?? "").toLowerCase().indexOf(this.options.search) > -1
                        || (model.get('type') ?? "").toLowerCase().indexOf(this.options.search) > -1;
                    break;
                default:
                    // crew
                    let person = model.get('person')
                    if (person != null) {
                        match = (person.contactName ?? "").toLowerCase().indexOf(this.options.search) > -1
                            || (person.companyName ?? "").toLowerCase().indexOf(this.options.search) > -1;
                    }
                    break;
            }

            if (match) {
                $sel.removeClass('hidden');
                hasMatch = true;

                if (this.filteredSelection != null) {
                    this.filteredSelection.push(model);
                }
            } else {
                $sel.addClass('hidden');
            }
        }, this);

        if (hasMatch) {
            this.$('.no-matches').addClass('hidden');
        } else {
            this.$('.no-matches').removeClass('hidden');
        }
    },
    optionSelected: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            selectedItem = this.selection.get(cid),
            isChecked = $target.is(':checked'),
            key = this.selectionOption === 'equipment' ? 'equipment' : 'people',
            id = selectedItem.get('personId') ?? selectedItem.get('id');

        if (!this.selectedItemIds[key]) {
            this.selectedItemIds[key] = [];
        }

        if (isChecked) {
            if (!_.contains(this.selectedItemIds[key], id)) {
                this.selectedItemIds[key].push(id);
            }
        } else {
            this.selectedItemIds[key] = _.without(this.selectedItemIds[key], id);
        }

        this.preserveScrollRender();
    },
    preserveScrollRender: function () {
        let selectionScroll = this.$('.selection-div').scrollTop();
        let selectedScroll = this.$('.selected-div').scrollTop();

        this.render();

        this.$('.selection-div').scrollTop(selectionScroll);
        this.$('.selected-div').scrollTop(selectedScroll);
    },
    selectAll: function () {
        let key = this.selectionOption === 'equipment' ? 'equipment' : 'people',
            selectionIds = _.map(this.filteredSelection != null ? this.filteredSelection : this.selection.models, item => item.get('personId') ?? item.get('id')),
            selectedIds = this.selectedItemIds[key] || [],
            allSelected = _.every(selectionIds, id => _.contains(selectedIds, id));
        if (allSelected) {
            this.selectedItemIds[key] = _.without.apply(_, [selectedIds].concat(selectionIds));
        } else {
            let idsToAdd = _.filter(selectionIds, id => !_.contains(selectedIds, id));
            this.selectedItemIds[key] = selectedIds.concat(idsToAdd);
        }

        this.preserveScrollRender();
    },
    removeAll: function () {
        this.selectedItemIds = {};

        this.preserveScrollRender();
    },
    removeSelectedItem: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid');

        let model = _.find(this.projectContacts.models, m => m.cid === cid) ||
            _.find(this.equipment.models, m => m.cid === cid) ||
            _.chain(this.crews.models).map(crew => crew.workers.get(cid)).find(m => !!m).value();


        if (!model) return;

        let id = model.get('personId') ?? model.get('id');

        _.each(this.selectedItemIds, (ids, key) => {
            if (_.contains(ids, id)) {
                this.selectedItemIds[key] = _.without(ids, id);
                return false;
            }
        });

        this.preserveScrollRender();
    },
    getSelectedItems: function () {
        let peopleIds = this.selectedItemIds.people || [],
            equipmentIds = this.selectedItemIds.equipment || [];

        let people = [];

        people = people.concat(
            _.filter(this.projectContacts.models, m => _.contains(peopleIds, m.get('personId') ?? m.get('id')))
        );

        _.each(this.crews.models, crew => {
            people = people.concat(
                _.filter(crew.workers.models, m => _.contains(peopleIds, m.get('personId') ?? m.get('id')))
            );
        });

        people = _.uniq(people, m => m.get('personId') ?? m.get('id'));

        let equipment = _.filter(this.equipment.models, m => _.contains(equipmentIds, m.get('id')));
        return {
            people,
            equipment
        };
    }
});

PJQ.views.timecards.BulkEntryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-bulk-entry'),
        minWidth: '1000px',
        timeCard: null,
        project: null,
        onSave: _.noop()
    },
    events: {
        'click .btn-apply': 'apply'
    },
    beforeModalCreated: function () {
        if (this.options.project != null) {
            this.options.permissions = this.options.project.permissions ? this.options.project.permissions : PJQ.app.session.project.permissions;
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;
        }
    },
    beforeRender: function () {
        this.options.enableOvertime = this.options.settings.get('enableOvertime');
        this.options.enableDoubletime = this.options.settings.get('enableDoubletime');
        this.options.enableLineItems = this.options.settings.get('enableLineItems');
        this.options.enableClockIn = this.options.settings.get('enableClockIn');
    },
    renderData: function () {
        return {
            settings: this.options.settings,
            enableOvertime: this.options.enableOvertime,
            enableDoubletime: this.options.enableDoubletime,
            enableLineItems: this.options.enableLineItems,
            enableClockIn: this.options.enableClockIn,
            model: this.model
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'textarea'
            ]
        });

        if (this.options.enableLineItems) {
            this.renderLineItems();
        } else {
            this.$('.regular-hours').focus().select();
        }
        this.renderInputs();
        this.renderTotals();
    },
    renderLineItems: function () {
        new PJQ.views.timecards.LineItemsView({
            el: this.$('.line-items-outer'),
            model: this.model,
            project: this.options.project,
            settings: this.options.settings,
            onLineItemChanged: () => {
                this.renderTotals();
            }
        });
    },
    renderInputs: function () {
        this.$('.regular-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('regularHours')));
        this.$('.overtime-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('overtimeHours')));
        this.$('.doubletime-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('doubletimeHours')));
        PJQ.helpers.inputHelpers.inputMaskHours(this.$('.input-hours'));

        if (this.options.enableClockIn) {
            new PJQ.inputs.Datepicker({
                el: this.$('.time-in'),
                isTimeOnly: true,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.model.get('timeIn')
                },
                onChange: (value) => {
                    this.model.set('timeIn', value);
                    this.renderTotals();
                }
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.time-out'),
                isTimeOnly: true,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.model.get('timeOut')
                },
                onChange: (value) => {
                    this.model.set('timeOut', value);
                    this.renderTotals();
                }
            });
        }
    },
    renderTotals: function () {
        if (!this.options.enableClockIn) {
            this.$('.total-regular-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('regularHours')));
        } else {
            let minutes = 0;
            if (this.options.enableLineItems) {
                _.each(this.model.lineItems.models, function (lineItem) {
                    if (lineItem.get('timeIn') != null && lineItem.get('timeOut') != null) {
                        minutes += PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(lineItem.get('timeOut')), new Date(lineItem.get('timeIn')));
                    }
                });
            } else if (this.model.get('timeIn') != null && this.model.get('timeOut') != null) {
                minutes = PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(this.model.get('timeOut')), new Date(this.model.get('timeIn')));
            }
            this.$('.total-regular-hours').text(minutes > 0 ? PJQ.helpers.formatHelpers.minutesToHHMM(minutes) : '00:00');
        }

        this.$('.total-overtime-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('overtimeHours')));
        this.$('.total-doubletime-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('doubletimeHours')));
    },
    apply: function () {
        if (this.options.timeCards && _.size(this.options.timeCards.models) > 0) {
            _.each(this.options.timeCards.models, (timeCard) => {
                timeCard.set({
                    notes: this.model.get('notes'),
                    doubletimeHours: this.model.get('doubletimeHours'),
                    overtimeHours: this.model.get('overtimeHours'),
                    regularHours: this.model.get('regularHours'),
                    timeIn: timeCard.get('timeIn'),
                    timeOut: timeCard.get('timeOut')
                });

                timeCard.lineItems.reset();

                _.each(this.model.lineItems.models, function (lineItem) {
                    let newLine = new PJQ.models.timecards.TimeCardLineItem({
                        doubletimeHours: lineItem.get('doubletimeHours'),
                        overtimeHours: lineItem.get('overtimeHours'),
                        regularHours: lineItem.get('regularHours'),
                        timeIn: lineItem.get('timeIn'),
                        timeOut: lineItem.get('timeOut'),
                        costCodeId: lineItem.get('costCodeId'),
                        notes: lineItem.get('notes'),
                    });

                    timeCard.lineItems.add(newLine);
                });
            }, this);
        }

        if (typeof this.options.onSave === 'function') {
            this.options.onSave();
        }

        this.removeModal();
    }
});
PJQ.views.timecards.ManageTimeCardsByWeekModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-manage-timecards-week'),
        maxWidth: '1400px',
        minWidth: '600px',
        onSave: _.noop(),
        onDelete: _.noop(),
        timeCardsView: null
    },
    events: {
        'click .last-week': 'lastWeek',
        'click .next-week': 'nextWeek',
        'click div.add-row-options a.dropdown-item': 'newRow',
        'click .timecards-save': 'saveClicked'
    },
    beforeModalCreated: function () {
        let today = new Date(PJQ.helpers.dateHelpers.getDateString(new Date(), PJQ.helpers.dateHelpers.dateFormats.DATE));
        this.startDate = new Date();
        switch (this.options.settings.get('weekStart')) {
            case 0: // Su
                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay()) % 7);
                break;
            default:
                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() + (7 - this.options.settings.get('weekStart'))) % 7);
                break;
        }

        if (this.options.project != null) {
            this.options.permissions = PJQ.app.session.project.permissions;

            let projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
                project: PJQ.app.session.project
            });

            projectContacts.fetch({
                success: _.bind(function () {
                    this.projectContacts = [];

                    if (this.options.permissions.hasPermission('timeCards.canViewAll')) {
                        this.projectContacts = projectContacts.models;

                        // add project user 2 to top if not present
                        if (PJQ.app.session.project.user2) {
                            if (_.size(_.filter(this.projectContacts, function (projectContact) {
                                return projectContact.get('id') === PJQ.app.session.project.user2.get('id');
                            })) === 0) {
                                this.projectContacts.unshift(PJQ.app.session.project.user2);
                            }
                        }

                        // add project user 1 to top if not present
                        if (PJQ.app.session.project.user) {
                            if (_.size(_.filter(this.projectContacts, function (projectContact) {
                                return projectContact.get('id') === PJQ.app.session.project.user.get('id');
                            })) === 0) {
                                this.projectContacts.unshift(PJQ.app.session.project.user);
                            }
                        }
                    }

                    // add current user to top if not present
                    if (_.size(_.filter(this.projectContacts, function (projectContact) {
                        return projectContact.get('id') === PJQ.app.session.user.get('id');
                    })) === 0) {
                        this.projectContacts.unshift(PJQ.app.session.user);
                    }

                    this.projectContacts = _.sortBy(this.projectContacts, function (user) {
                        return user.get('contactName') ? user.get('contactName').toLowerCase() : '';
                    });

                    this.render();
                }, this)
            });
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;

            if (this.options.permissions.hasPermission('timeCards.canViewAll')) {
                PJQ.app.session.fetchUsers(_.bind(function (users) {
                    this.users = _.sortBy(users.models, function (user) {
                        return user.get('contactName') ? user.get('contactName').toLowerCase() : '';
                    });
                    this.render();
                }, this));
            } else {
                this.users = [PJQ.app.session.user];
                this.render();
            }
        }
    },
    afterRender: function () {
        if (!this.users && !this.projectContacts)
            return;

        this.datePicker = new PJQ.inputs.Datepicker({
            el: this.$('.select-week-input'),
            datepickerOptions: {
                defaultDate: this.startDate,
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
            },
            disabledDays: _.filter([0, 1, 2, 3, 4, 5, 6], _.bind(function (day) {
                return day !== this.options.settings.get('weekStart');
            }, this)),
            onChange: _.bind(function (value) {
                this.renderWeek(value);
            }, this)
        });

        if (PJQ.app.session.project) {
            _.each(this.projectContacts, _.bind(function (user) {
                this.$('.select-context').append("<option value='" + user.get('id') + "'>" + user.get('contactName') + "</option>");
            }, this));
        } else {
            _.each(this.users, _.bind(function (user) {
                this.$('.select-context').append("<option value='" + user.get('id') + "'>" + user.get('contactName') + "</option>");
            }, this));
        }

        this.context = PJQ.app.session.user;

        this.contextSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-context'),
            isIntChoices: true,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: this.context.get('id'),
            onHide: _.bind(function () {
                if (this.context.get('id') !== this.contextSelectPicker.getValue()) {
                    if (PJQ.app.session.project) {
                        _.each(this.projectContacts, _.bind(function (user) {
                            if (user.get('id') === this.contextSelectPicker.getValue()) {
                                this.context = user;
                                this.renderWeek();
                            }
                        }, this));
                    } else {
                        _.each(this.users, _.bind(function (user) {
                            if (user.get('id') === this.contextSelectPicker.getValue()) {
                                this.context = user;
                                this.renderWeek();
                            }
                        }, this));
                    }
                }
            }, this)
        });

        this.renderWeek();
    },
    renderWeek: function (newDate = null) {
        if (newDate)
            this.startDate = newDate;

        this.projects = null;
        this.rows = [];
        this.$('.timecards-list, .add-row-options').empty();
        this.$('.timecards-empty').removeClass('hidden');

        let fnContinue = _.bind(function () {
            this.projects = new PJQ.collections.timecards.TimeCardContextProjects(null, {
                id: this.context.get('id'),
                startDate: this.startDate,
                endDate: PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 7)
            });

            this.projects.fetch({
                success: _.bind(function () {
                    this.$('.add-row-options').append("<a class='dropdown-item hidden no-projects' data-project-id='0' disabled='disabled'><span class='text-muted'>No Projects Available</span></a>");

                    if (PJQ.app.session.project) {
                        let hasLocation = (_.size(PJQ.app.session.project.get('city')) + _.size(PJQ.app.session.project.get('state')) > 0);
                        this.$('.add-row-options').append("<a class='dropdown-item project' data-project-id='" + PJQ.app.session.project.get('projectId') + "' title='" + PJQ.app.session.project.get('projectName') + (hasLocation ? (' - ' + PJQ.app.session.project.get('city') + ', ' + PJQ.app.session.project.get('state')) : '') + "'>" + PJQ.app.session.project.get('projectName') + "</a>");
                    } else if (_.size(this.projects.models) > 0) {
                        _.each(this.projects.models, _.bind(function (project) {
                            let hasLocation = (_.size(project.get('city')) + _.size(project.get('state')) > 0);
                            this.$('.add-row-options').append("<a class='dropdown-item project' data-project-id='" + project.get('projectId') + "' title='" + project.get('projectName') + (hasLocation ? (' - ' + project.get('city') + ', ' + project.get('state')) : '') + "'>" + project.get('projectName') + "</a>");
                        }, this));
                    } else {
                        this.$('.add-row-options .dropdown-item[data-project-id="0"]').removeClass('hidden');
                    }

                    if (_.size(this.categories.models) > 0) {
                        this.$('.add-row-options').append("<div class='dropdown-divider'></div>");
                    }

                    _.each(this.categories.models, _.bind(function (category) {
                        this.$('.add-row-options').append("<a class='dropdown-item category' data-project-id='-" + category.get('timeCardCategoryId') + "'>" + category.get('name') + "</a>");
                    }, this));

                    let dateFormat = "ddd, " + PJQ.helpers.dateHelpers.dateFormats.DATE_MONTH_DAY,
                        tempDate = new Date(this.startDate.valueOf());
                    for (var i = 0; i < 7; i++) {
                        this.$('div.timecards-header div[data-day-column="' + i + '"]').text(PJQ.helpers.dateHelpers.getDateString(tempDate, dateFormat));
                        tempDate.setDate(tempDate.getDate() + 1);
                    }

                    let idFilter = 0;
                    if (this.options.contact)
                        idFilter = this.options.contact.get('id');
                    else {
                        if (!this.options.permissions.hasPermission('contacts.canView') && (PJQ.app.session.project === null || !this.options.permissions.hasPermission('canViewAll')))
                            idFilter = -PJQ.app.session.user.id;
                    }

                    let dateNow = new Date(), parameters = {
                        searchFor: '',
                        startDate: PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        endDate: PJQ.helpers.dateHelpers.getDateString(PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 6), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        page: 1,
                        pageSize: 2147483646,
                        orderBy: 'project.projectId',
                        orderDirection: 'asc',
                        projectId: PJQ.app.session.project ? PJQ.app.session.project.get('projectId') : 0,
                        idFilter: this.context.get('id'),
                        timeZoneOffset: dateNow.getTimezoneOffset()
                    }, timecards = new PJQ.collections.timecards.TimeCards();

                    timecards.fetch({
                        data: parameters,
                        success: _.bind(function () {
                            let newRows = [];
                            _.each(timecards.models, _.bind(function (timecard) {
                                if (_.size(_.filter(newRows, function (row) {
                                    return row.project.projectId == timecard.get('projectId');
                                })) === 0) {
                                    // iterate through the models in each newRow and add any missing dates for this date range.
                                    let models = [];

                                    for (let j = 0; j < 7; j++) {
                                        let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, j),
                                            sourceModels = _.filter(timecards.models, function (timecard2) {
                                                return timecard2.projectId === timecard.projectId;
                                            });

                                        let existingModels = _.filter(sourceModels, function (timecard2) {
                                            return timecard2.get('projectId') === timecard.get('projectId') && timecard2.get('date').getTime() === PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)).getTime();
                                        });

                                        if (_.size(existingModels) === 0) {
                                            models.push(new PJQ.models.timecards.TimeCard({
                                                projectId: timecard.get('projectId'),
                                                project: timecard.get('project'),
                                                contact: timecard.get('contact'),
                                                id: timecard.get('id'),
                                                date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
                                                notes: '',
                                                regularHours: 0,
                                                overtimeHours: 0,
                                                doubletimeHours: 0,
                                                createdBy: -PJQ.app.session.user.id
                                            }));
                                        } else {
                                            models.push(existingModels[0]);
                                        }
                                    }

                                    newRows.push({
                                        project: timecard.get('project'),
                                        models: models
                                    });
                                }
                            }, this));

                            if (_.size(newRows) > 0) {
                                _.each(newRows, _.bind(function (newRow) {
                                    this.addRow(newRow);
                                }, this));
                            } else if (PJQ.app.session.project) {
                                this.$('.add-row-options .dropdown-item.project[data-project-id="' + PJQ.app.session.project.get('projectId') + '"]').click();
                            }
                        }, this)
                    });

                    this.recalculateTotals();
                }, this)
            });
        }, this);

        // load categories
        if (this.categories == null) {
            this.categories = new PJQ.collections.timecards.TimeCardCategories();
            this.categories.fetch({
                success: _.bind(function () {
                    fnContinue();
                }, this)
            });
        } else {
            fnContinue();
        }
    },
    captureSignature: function (callback) {
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_TIMECARDS_SIGNATURE)) {
            new PJQ.views.signatures.SignatureSubmitModal({
                headerSubText: "Sign off on your time card changes",
                onSubmit: _.bind(function (signature, cb) {
                    cb();
                    callback(signature ? signature : "");
                }, this)
            });
        } else {
            callback(null);
        }
    },
    lastWeek: function () {
        let fnContinue = _.bind(function () {
            let date = new Date(this.startDate.valueOf());
            date.setDate(date.getDate() - 7);
            this.datePicker.setValue(date);
            this.renderWeek(date);
        }, this);

        if (_.size(this.rows) > 0) {

            this.save(_.bind(function () {
                fnContinue();
            }, this));

        } else
            fnContinue();
    },
    nextWeek: function () {
        let fnContinue = _.bind(function () {
            let date = new Date(this.startDate.valueOf());
            date.setDate(date.getDate() + 7);
            this.datePicker.setValue(date);
            this.renderWeek(date)
        }, this);

        if (_.size(this.rows) > 0) {
            this.save(_.bind(function () {
                fnContinue();
            }, this));
        } else
            fnContinue();
    },
    newRow: function (e) {
        let projectId = $(e.currentTarget).data('projectId'), newRow = {};

        if (projectId === 0)
            return;

        if (projectId > 0) {
            _.each(this.projects.models, _.bind(function (project) {
                if (project.get('id') == projectId) {
                    newRow.project = project.attributes;
                }
            }, this));

            if (!newRow.project && PJQ.app.session.project)
                newRow.project = PJQ.app.session.project.attributes;
        } else {
            // find category
            _.each(this.categories.models, _.bind(function (category) {
                if (category.get('timeCardCategoryId') == projectId * -1) {
                    newRow.project = {
                        projectId: category.get('timeCardCategoryId') * -1,
                        projectName: category.get('name')
                    };
                }
            }, this));
        }

        // add new models for the days of this work week
        newRow.models = [];
        for (let i = 0; i < 7; i++) {
            let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, i);
            newRow.models.push(new PJQ.models.timecards.TimeCard({
                projectId: projectId,
                project: newRow.project,
                contact: this.context.attributes,
                id: this.context.get('id'),
                date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
                notes: '',
                regularHours: 0,
                overtimeHours: 0,
                doubletimeHours: 0,
                createdBy: -PJQ.app.session.user.id
            }));
        }

        this.addRow(newRow);
    },
    addRow: function (row) {
        this.$('.timecards-empty').addClass('hidden');
        this.$('.add-row-options a.dropdown-item[data-project-id="' + row.project.projectId + '"]').addClass('hidden');
        if (_.size(this.$('.add-row-options a.dropdown-item.category:not(.hidden)')) === 0)
            this.$('.add-row-options .dropdown-divider').addClass('hidden');

        if (_.size(this.$('.add-row-options a.dropdown-item.project:not(.hidden)')) === 0)
            this.$('.add-row-options .dropdown-item.no-projects').removeClass('hidden');

        let self = this;
        this.rows.push(new PJQ.inputs.timecards.TimeCardWeekEditor({
            el: $('<div class="time-card-week" />').appendTo(this.$('.timecards-list')),
            settings: this.options.settings,
            project: this.options.project,
            row: row,
            startDate: this.startDate,
            onChange: _.bind(function () {
                setTimeout(function () {
                    self.recalculateTotals();
                }, 200);
            }, this),
            onDelete: function () {
                this.el.addClass('hidden');
                self.$('.add-row-options a.dropdown-item[data-project-id="' + row.project.projectId + '"]').removeClass('hidden');

                // handle New Row dropdowns depending on if project or category
                if (this.row.project.projectId > 0) {
                    // if at least one visible project in the list exists, hide the 'no projects' item
                    if (_.size(self.$('.add-row-options a.dropdown-item.project:not(.hidden)')) > 0)
                        self.$('.add-row-options .dropdown-item.no-projects').addClass('hidden');
                    else
                        self.$('.add-row-options .dropdown-item.no-projects').removeClass('hidden');
                } else {
                    // at least one category now exists, so show the divider
                    self.$('.add-row-options .dropdown-divider').removeClass('hidden');
                }

                if (_.size(self.$('.timecards-list .time-card-week:not(".hidden")')) == 0)
                    self.$('.timecards-empty').removeClass('hidden');

                self.recalculateTotals();
            }
        }));
    },
    recalculateTotals: function () {
        let grandTotalMinutes = 0;
        for (let i = 0; i < 7; i++) {
            let totalMinutes = 0;

            // loop through each day, and then through each row and get the daytotal
            let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, i);
            _.each(this.rows, _.bind(function (row) {
                totalMinutes += row.getTotalTimeForDate(date);
            }, this));

            grandTotalMinutes += totalMinutes;

            this.$('.timecards-footer .time-card-day-total[data-day-column="' + i + '"]').text(PJQ.helpers.timecards.getFormattedTime(totalMinutes));
        }

        this.$('.timecards-footer .time-card-total[data-day-column="total"]').text(PJQ.helpers.timecards.getFormattedTime(grandTotalMinutes));
    },
    save: function (callback) {
        let timecards = [];
        _.each(this.rows, _.bind(function (row) {
            if (row.hasChanges()) {
                timecards.push(..._.filter(row.options.row.models, function (model) {
                    return !model.isNew() || !model.get('deletedOn');
                }));
            }
        }, this));

        let signTimecards = _.filter(timecards, function (timecard) {
            return timecard.get('id') === -PJQ.app.session.user.id;
        }), fnSave = _.bind(function (signature) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'timecards',
                    },
                    {
                        endpoint: 'batch'
                    }
                ]),
                data: {
                    signature: signature,
                    rows: timecards
                },
                isAPIv2: true
            }).post().success(_.bind(function (data) {
                PJQ.notifications.notify.successNotify({
                    message: 'Timecard changes saved sucessfully'
                });
                this.options.onSave();
                callback();
            }, this));
        }, this)
        if (_.size(signTimecards) > 0) {
            this.captureSignature(_.bind(function (signature) {
                fnSave(signature);
            }, this));
        } else if (_.size(timecards) > 0) {
            fnSave();
        } else {
            callback();
        }
    },
    saveClicked: function () {
        this.save(_.bind(function () {
            this.removeModal();
        }, this));
    }
});
PJQ.views.timecards.BaseDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Results Available"
        },
        isHideSearch: true,
        dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>',
        phoneWidth: '125px'
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-fax': 'copyPhone',
        'click .btn-copy-cell': 'copyPhone',
        'click .btn-copy-email': 'copyEmail'
    },
    beforeDataTableRender: function () {
        this.options.rowCallback = function (row, data) {
        };

        if (this.options.project != null) {
            this.options.permissions = PJQ.app.session.project.permissions;
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;
        }

        this.options.childDataTables = [];

        this.options.contextMenuOptions = {
            actions: this.getContextMenuItems(),
            isHideNoActions: true
        };

        this.options.onRowDoubleClick = _.bind(function (row) {
            if (row.data()) {
                this.editRow(row.data());
            }
        }, this);

        if (this.options.settings) {
            // enable paging for grids that have a setting for it / are not subgrids
            if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
                this.options.pageLength = this.options.settings.rowsPerPage;
            else
                this.options.pageLength = 2147483646;

            if (this.options.settings.orderBy !== 'sortOrder') {
                if (_.size(this.options.settings.columns) === 0) {
                    this.options.settings.orderBy = this.options.settings.columnsDefault[0];
                } else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
                    this.options.settings.orderBy = this.options.settings.columns[0];
                }
            }
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy) {
                    this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
                }
            }, this));

        }

        this.options.createdRow = _.bind(this.createdRow, this);

        if (typeof this.options.beforeDataTableRender === 'function') {
            this.options.beforeDataTableRender();
        }
    },
    afterDataTableRender: function () {
        this.$el.on('order.dt', _.bind(function (e, settings, details) {
            if (this.$dataTable[0].id !== settings.oInstance[0].id)
                return;

            if (!this.options.settings)
                return;

            let oldOrder = 0, columns = this.getColumns(false);
            _.each(columns, _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy)
                    oldOrder = index;
            }, this));

            if (oldOrder !== details[details.length - 1].src || this.options.settings.orderAscending !== (details[details.length - 1].dir === 'asc')) {
                this.options.settings.orderBy = columns[details[details.length - 1].src].columnData;
                this.options.settings.orderAscending = details[details.length - 1].dir === 'asc';
                this.options.timecardsView.userSettings.save();
            }
        }, this));

        this.$el.on('draw.dt', _.bind(function () {
            this.afterDataTableRenderChild();
        }, this));

        if (typeof this.options.afterDataTableRender === 'function') {
            this.options.afterDataTableRender(this.dataTable);
        }

        this.afterDataTableRenderChild();
    },
    columnOrderChanged: function (columns) {
        if (this.options.userSettings != null) {
            let settings = this.options.userSettings.get('viewSettings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.view) {
                    settings[i].columns = columns;
                }
            }

            this.options.userSettings.set('viewSettings', settings);
            this.options.userSettings.save();
        }
    },
    afterDataTableRenderChild: function () {
    },
    getRowChildTable: function (childOpts) {
    },
    getRowChildData: function (row) {
    },
    setRowStyle: function (row, status, isBlacklisted) {
    },
    getContextMenuItems: function () {
    },
    editRow: function (model) {
    },
    statusChanged: function (statuses) {
    },
    childRowToggle: function (sender, rowOverride) {
        let $target = rowOverride ? $(rowOverride.selector.rows).find('.timecard-dataentry-toggle-row') : $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);

        if (row.child.isShown() && rowOverride == null) {
            // This row is already open - close it
            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                return childDt.options.parentId !== id;
            }, this));
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');

            this.renderChildRow(row, id);
        }
    },
    renderChildRow: function (row, parentId) {
        //row.child.hide();
        let childClass = 'subgrid-' + parentId.toString(),
            $childTable = $('<div data-id="' + parentId + '" />', {
                class: childClass + ' p-2'
            });
        row.child($childTable).show();

        let childData = this.getRowChildData(row);
        if (childData != null) {
            if (this.options.view === PJQ.constants.timecards.view.BY_TIMECARD_DATAENTRY ||
                this.options.view === PJQ.constants.timecards.view.BY_TIMECARD ||
                this.options.view === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD ||
                this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD ||
                this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD) {
                let childTable = this.getRowChildTable({
                    el: $childTable,
                    data: childData,
                    parentId: parentId,
                    onApprove: this.options.onApprove,
                    isApproved: row.data().get('approvedOn') ? true : false,
                    timecardsView: this.options.timecardsView
                });
                this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                    return childDt.options.parentId !== parentId;
                }, this));
                this.options.childDataTables.push(childTable);
            } else {
                let settings = this.getChildTableSettings(),
                    dateNow = new Date(),
                    parameters = {
                        searchFor: this.options.timecardsView.$('.input-search').val(),
                        startDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        endDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        page: 1,
                        pageSize: 2147483646,
                        orderBy: settings.orderBy,
                        orderDirection: settings.orderAscending ? 'asc' : 'desc',
                        timeZoneOffset: dateNow.getTimezoneOffset(),
                        projectId: childData.options.projectId,
                        idFilter: childData.options.idFilter,
                        isEquipment: childData.options.isEquipment
                    };

                let loader = new PJQ.Loader(this.$el.parent());
                childData.fetch({
                    type: 'GET',
                    data: parameters,
                    success: _.bind(function () {
                        loader.remove();
                        let childTable = this.getRowChildTable({
                            el: $childTable,
                            data: childData.models,
                            parentId: parentId,
                            isEquipment: childData.options.isEquipment,
                            timecardsView: this.options.timecardsView
                        });
                        this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                            return childDt.options.parentId !== parentId;
                        }, this));
                        this.options.childDataTables.push(childTable);
                        //tr.addClass('shown');
                    }, this)
                });
            }
        }
    },
    getColumns: function () {
    },
    cleanup: function () {
        this.undelegateEvents();
        $(this.el).empty();
    },
    getIsRootView: function () {
        return (this.options.view.indexOf('-') === -1);
    },
    createdRow: function (row, data, dataIndex) {
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    },
    fetchTimeCards: async function (data) {
        if (data == null || typeof this.options.onApprove !== 'function') {
            return;
        }

        let timeCards;
        if (data.timeCards != null) {
            timeCards = data.timeCards;
        } else if (data.idFilter != null || data.projectId != null) {
            timeCards = new PJQ.collections.timecards.TimeCards(null, {
                projectId: data.projectId,
                idFilter: data.idFilter,
                isEquipment: data.isEquipment
            });

            let dateNow = new Date(),
                parameters = {
                    startDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                    endDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                    page: 1,
                    pageSize: 2147483646,
                    timeZoneOffset: dateNow.getTimezoneOffset(),
                    projectId: timeCards.options.projectId,
                    idFilter: timeCards.options.idFilter,
                    isEquipment: timeCards.options.isEquipment
                };

            await timeCards.fetch({
                type: 'GET',
                data: parameters
            });
        }

        return timeCards;
    }
});

PJQ.views.timecards.ProjectDataTable = PJQ.views.timecards.BaseDataTable.extend({
    events: {
        'click i.project-toggle-row': 'childRowToggle',
        'click .approve-project-time-cards': 'approveTimeCardsClicked',
        'click .unapprove-project-time-cards': 'approveTimeCardsClicked',
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Approve Time Cards',
                iconClass: 'fal fa-calendar-check',
                onClick: _.bind(function (row) {
                    this.approveTimeCards(null, row);
                }, this),
                isShown: _.bind(function (row) {
                    return this.options.permissions.hasPermission('timeCards.canApprove');
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['projectId', 'projectName', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'bidsDue', 'startDate', 'endDate', 'regularHours', 'overtimeHours', 'doubletimeHours'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT ||
                this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT) {
                columns.push({
                    "columnData": "childData",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal expand-item fa-plus-circle project-toggle-row" data-type="projectId" data-id="' + row.get('projectId') + '"></i>';
                    }
                });
            }
        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'projectId':
                    columns.push({
                        "columnData": "projectId",
                        "data": "attributes.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "columnData": "projectName",
                        "data": "attributes.projectName",
                        "title": "Project",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return data;
                            }

                            return '<a href="#/projects/' + row.get('projectId') + '" data-id="' + row.id + '">' + data + '</a>';
                        }
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country"
                    });
                    break;
                case 'bidsDue':
                    columns.push({
                        "columnData": "bidsDue",
                        "data": "attributes.bidsDue",
                        "title": 'Bids Due',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('bidsDue')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'startDate':
                    columns.push({
                        "columnData": "startDate",
                        "data": "attributes.startDate",
                        "title": 'Start Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('projectId') > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('startDate')), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'endDate':
                    columns.push({
                        "columnData": "endDate",
                        "data": "attributes.endDate",
                        "title": 'End Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('projectId') > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'regularHours':
                    columns.push({
                        "columnData": "regularHours",
                        "data": "attributes.regularHours",
                        "title": 'Reg. Hours',
                        "width": '120px',
                        "orderable": true,
                        "className": 'regularHours',
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('regularHours'));
                        }
                    });
                    break;
                case 'overtimeHours':
                    columns.push({
                        "columnData": "overtimeHours",
                        "data": "attributes.overtimeHours",
                        "title": 'OT Hours',
                        "width": '120px',
                        "orderable": true,
                        "className": 'overtimeHours',
                        "visible": this.options.timeCardSettings.get('enableOvertime'),
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('overtimeHours'));
                        }
                    });
                    break;
                case 'doubletimeHours':
                    columns.push({
                        "columnData": "doubletimeHours",
                        "data": "attributes.doubletimeHours",
                        "title": 'DT Hours',
                        "width": '120px',
                        "orderable": true,
                        "className": 'doubletimeHours',
                        "visible": this.options.timeCardSettings.get('enableDoubletime'),
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('doubletimeHours'));
                        }
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    html += '<div class="show-on-row-hover">';

                    if (this.options.permissions.hasPermission('timeCards.canApprove')) {
                        html += row.get('approvedOn') ? '<button type="button" class="btn btn-secondary unapprove-project-time-cards ml-1" title="Un-Approve Time Cards"><i class="fal fa-calendar-times"></i></button>' : '<button type="button" class="btn btn-secondary approve-project-time-cards ml-1" title="Approve Time Cards"><i class="fal fa-calendar-check"></i></button>';
                    }

                    html += '</div>';
                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "50px",
                "className": "text-center"
            });
        }

        return columns;
    },
    getChildTableType: function () {
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT)
            return PJQ.constants.timecards.view.BY_PROJECT_CONTACT;
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT)
            return PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD;
    },
    getChildTableSettings: function () {
        return this.options.timecardsView.userSettings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {

        let fixedColumnsLeft = 1, fixedColumnsRight = 0;
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT) {
            fixedColumnsLeft = 1;
            fixedColumnsRight = 1;
        }

        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.timecardsView.userSettings;
        childOpts.colReorder = {
            fixedColumnsLeft: fixedColumnsLeft,
            fixedColumnsRight: fixedColumnsRight,
            realtime: false
        };
        childOpts.timecardsView = this.options.timecardsView;
        childOpts.onApprove = this.options.onApprove;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.timeCardSettings = this.options.timeCardSettings;

        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT)
            return new PJQ.views.timecards.ContactDataTable(childOpts);
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT)
            return new PJQ.views.timecards.TimeCardDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: this.getChildTableType(),
            projectId: row.data().get('projectId'),
        };

        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT)
            return new PJQ.collections.timecards.TimeCardContacts(null, viewOptions);
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT) {
            viewOptions.idFilter = this.options.parentId;
            viewOptions.isEquipment = this.options.isEquipment;
            return new PJQ.collections.timecards.TimeCards(null, viewOptions);
        }
    },
    approveTimeCardsClicked: async function (e) {
        if (typeof this.options.onApprove !== 'function') {
            return;
        }

        let $target = $(e.currentTarget),
            row = this.getRow($target.closest('tr')),
            project = row.data();
        if (project.timeCards == null) {
            let loader = new PJQ.Loader($target);
            project.timeCards = await this.fetchTimeCards({
                projectId: project.get('projectId'),
                idFilter: this.options.parentId,
                isEquipment: this.options.isEquipment
            })
            loader.remove();
        }

        if (_.size(project.timeCards.models.filter((c) => {
            return c.get('approvedOn') == null;
        })) === 0) {
            PJQ.notifications.notify.warningNotify({
                message: 'This project has no time cards to approve for the selected dates'
            });
            return;
        }

        let approveNote;
        if (project.timeCards.options.idFilter != null) {
            approveNote = "Are you sure you want to approve this contact's time cards for the selected project?";
        } else {
            approveNote = "Are you sure you want to approve this project's time cards for all contacts?";
        }
        new PJQ.views.modals.YesNo({
            header: "Approve Time Cards",
            body: approveNote,
            onYes: _.bind(function () {
                this.options.onApprove(project.timeCards.models, true, () => {
                    row.invalidate().draw();
                });
            }, this)
        });
    },
    approveTimeCards: async function (e, row) {
        if (typeof this.options.onApprove !== 'function') {
            return;
        }

        let $target = null;
        if (e != null) {
            $target = $(e.currentTarget);
            row = this.getRow($target.closest('tr'));
        }

        let project = row.data();
        if (project.timeCards == null) {
            let loader = null;
            if ($target != null) {
                loader = new PJQ.Loader($target);
            }

            project.timeCards = await this.fetchTimeCards({
                projectId: project.get('projectId'),
                idFilter: this.options.parentId,
                isEquipment: this.options.isEquipment
            })

            if (loader != null) {
                loader.remove();
            }
        }

        if (_.size(project.timeCards.models.filter((c) => {
            return c.get('approvedOn') == null;
        })) === 0) {
            PJQ.notifications.notify.warningNotify({
                message: 'This project has no time cards to approve for the selected dates'
            });
            return;
        }

        let approveNote;
        if (project.timeCards.options.idFilter != null) {
            approveNote = "Are you sure you want to approve this contact's time cards for the selected project?";
        } else {
            approveNote = "Are you sure you want to approve this project's time cards for all contacts?";
        }
        new PJQ.views.modals.YesNo({
            header: "Approve Time Cards",
            body: approveNote,
            onYes: _.bind(function () {
                this.options.onApprove(project.timeCards.models, true, () => {
                    row.invalidate().draw();
                });
            }, this)
        });
    }
});

PJQ.views.timecards.ContactDataTable = PJQ.views.timecards.BaseDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'click .approve-contact-time-cards': 'approveTimeCardsClicked',
        'click .unapprove-contact-time-cards': 'approveTimeCardsClicked',
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Approve Time Cards',
                iconClass: 'fal fa-calendar-check',
                onClick: _.bind(function (row) {
                    this.approveTimeCards(null, row);
                }, this),
                isShown: _.bind(function (row) {
                    return this.options.permissions.hasPermission('timeCards.canApprove');
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['assignedTo', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'fax', 'cell', 'email', 'userTypeId', 'regularHours', 'overtimeHours', 'doubletimeHours'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT ||
                this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT) {
                columns.push({
                    "columnData": "childData",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return `<i class="fal fa-plus-circle expand-item contact-toggle-row" data-type="id" data-is-equipment="${row.get('equipmentId') > 0}" data-id="${row.get('equipmentId') > 0 ? row.get('equipmentId') : row.get('id')}"></i>`;
                    }
                });
            }
        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        // Previously there was a contactName and companyName column that have combined into assignedTo.
        // To support these old columns we check if contactName or companyName are in the includedColumns.
        // If they are we render assignedTo. To prevent duplicate columns we need to check if it's already been rendered.
        let renderedAssignedTo = false;
        _.each(includeColumns, _.bind(function (columnName) {
            if(renderedAssignedTo && (columnName === 'assignedTo' || columnName === 'companyName' || columnName === 'contactName')){
                return;
            }

            switch (columnName) {
                case 'assignedTo':
                case 'contactName':
                case 'companyName':
                    renderedAssignedTo = true;
                    columns.push({
                        "columnData": "assignedTo",
                        "data": "",
                        "title": "Assigned To",
                        "render": (data, type, row) => {
                            if(row.get('equipmentId') != null && row.get('equipmentId') > 0){
                                return `<div class="fs-16">${row.get('equipment')?.name}</div><div class="fs-14">${row.get('equipment')?.type}</div>`;
                            } else {
                                return `<div class="fs-16">${row.get('contactName')}</div><div class="fs-14">${row.get('companyName')}</div>`
                            }
                        },
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country"
                    });
                    break;
                case 'phone':
                    columns.push({
                        "columnData": "phone",
                        "data": "attributes.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'cell':
                    columns.push({
                        "columnData": "cell",
                        "data": "attributes.cell",
                        "title": "Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'fax':
                    columns.push({
                        "columnData": "fax",
                        "data": "attributes.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'email':
                    columns.push({
                        "columnData": "email",
                        "data": "attributes.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('email') ? ('<a title="' + row.get('email') + '" style="color: inherit;" href="mailto:' + row.get('email') + '">' + row.get('email') + '</a>') : '');

                            if (row.get('email') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'userTypeId':
                    columns.push({
                        "columnData": 'userTypeId',
                        "title": 'Type',
                        "data": 'attributes.userTypeId',
                        "render": function (data, type, row) {
                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(null), _.bind(function (userType) {
                                return row.get('userTypeId') === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'regularHours':
                    columns.push({
                        "columnData": "regularHours",
                        "data": "attributes.regularHours",
                        "title": 'Reg. Hours',
                        "width": '120px',
                        "orderable": true,
                        "className": 'regularHours',
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('regularHours'));
                        }
                    });
                    break;
                case 'overtimeHours':
                    columns.push({
                        "columnData": "overtimeHours",
                        "data": "attributes.overtimeHours",
                        "title": 'OT Hours',
                        "width": '120px',
                        "orderable": true,
                        "className": 'overtimeHours',
                        "visible": this.options.timeCardSettings.get('enableOvertime'),
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('overtimeHours'));
                        }
                    });
                    break;
                case 'doubletimeHours':
                    columns.push({
                        "columnData": "doubletimeHours",
                        "data": "attributes.doubletimeHours",
                        "title": 'DT Hours',
                        "width": '120px',
                        "orderable": true,
                        "className": 'doubletimeHours',
                        "visible": this.options.timeCardSettings.get('enableDoubletime'),
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('doubletimeHours'));
                        }
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    html += '<div class="show-on-row-hover">';

                    if (this.options.permissions.hasPermission('timeCards.canApprove')) {
                        html += row.get('approvedOn') ? '<button type="button" class="btn btn-secondary unapprove-contact-time-cards" title="Un-Approve Time Cards"><i class="fal fa-calendar-times"></i></button>' : '<button type="button" class="btn btn-secondary approve-contact-time-cards ml-1" title="Approve Time Cards"><i class="fal fa-calendar-check"></i></button>';
                    }

                    html += '</div>';
                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "80px",
                "className": "text-center"
            });
        }

        return columns;
    },
    getChildTableType: function () {
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT)
            return PJQ.constants.timecards.view.BY_CONTACT_PROJECT;
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT)
            return PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD;
    },
    getChildTableSettings: function () {
        return this.options.timecardsView.userSettings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {

        let fixedColumnsLeft = 1, fixedColumnsRight = 0;
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT) {
            fixedColumnsLeft = 1;
            fixedColumnsRight = 1;
        }

        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.timecardsView.userSettings;
        childOpts.colReorder = {
            fixedColumnsLeft: fixedColumnsLeft,
            fixedColumnsRight: fixedColumnsRight,
            realtime: false
        };
        childOpts.timecardsView = this.options.timecardsView;
        childOpts.onApprove = this.options.onApprove;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.timeCardSettings = this.options.timeCardSettings;

        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT)
            return new PJQ.views.timecards.ProjectDataTable(childOpts);
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT)
            return new PJQ.views.timecards.TimeCardDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: this.getChildTableType(),
            idFilter: row.data().get('equipmentId') > 0 ? row.data().get('equipmentId') : row.data().get('id'),
            isEquipment: row.data().get('equipmentId') > 0
        };

        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT)
            return new PJQ.collections.timecards.TimeCardProjects(null, viewOptions);
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT) {
            viewOptions.projectId = this.options.parentId;
            return new PJQ.collections.timecards.TimeCards(null, viewOptions);
        }
    },
    approveTimeCardsClicked: async function (e, row) {
        return await this.approveTimeCards(e);
    },
    approveTimeCards: async function (e, row) {
        if (typeof this.options.onApprove !== 'function') {
            return;
        }

        let $target = null;
        if (e != null) {
            $target = $(e.currentTarget);
            row = this.getRow($target.closest('tr'));
        }

        let contact = row.data();
        if (contact.timeCards == null) {
            let loader = null;
            if ($target != null) {
                loader = new PJQ.Loader($target);
            }

            contact.timeCards = await this.fetchTimeCards({
                projectId: this.options.parentId,
                idFilter: contact.get('equipmentId') > 0 ? contact.get('equipmentId') : contact.get('id'),
                isEquipment: contact.get('equipmentId') > 0
            })

            if (loader != null) {
                loader.remove();
            }
        }

        if (_.size(contact.timeCards.models.filter((c) => {
            return c.get('approvedOn') == null;
        })) === 0) {
            PJQ.notifications.notify.warningNotify({
                message: 'This contact has no time cards to approve for the selected dates'
            });
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Approve Time Cards",
            body: "Are you sure you want to approve this contact's time cards for " + (contact.timeCards.options.projectId > 0 ? 'the selected project' : 'all projects') + "?",
            onYes: () => {
                this.options.onApprove(contact.timeCards.models, true, () => {
                    row.invalidate().draw();
                });
            }
        });
    }
});

PJQ.views.timecards.TimeCardDataTable = PJQ.views.timecards.BaseDataTable.extend({
    events: {
        'click i.timecard-toggle-row': 'childRowToggle',
        'click .view-time-card': 'viewTimeCardClicked',
        'click .delete-time-card': 'deleteTimeCardClicked',
        'click .approve-time-card': 'approveTimeCardClicked',
        'click .unapprove-time-card': 'approveTimeCardClicked',
        'click .select-all-timecards': 'selectAll',
        'click .select-timecard': 'selectTimeCard'
    },
    onRowDoubleClick: function (row) {
        this.viewTimeCard(row);
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Approve Time Card',
                iconClass: 'fal fa-calendar-check',
                onClick: _.bind(function (row) {
                    this.approveTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return ((PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin'))) && !row.data().get('approvedOn'));
                }, this)
            },
            {
                name: 'Un-Approve Time Card',
                iconClass: 'fal fa-calendar-times',
                onClick: _.bind(function (row) {
                    this.approveTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return ((PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin'))) && _.size(row.data().get('approvedOn')) > 0);
                }, this)
            },
            {
                name: 'View Time Card',
                iconClass: 'fal fa-arrow-alt-from-left',
                onClick: _.bind(function (row) {
                    this.viewTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return true;
                }, this)
            },
            {
                name: 'Delete Time Card',
                iconClass: 'fal fa-trash',
                onClick: _.bind(function (row) {
                    this.deleteTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return (!row.data().get('approvedOn') && (this.options.permissions.hasPermission('timeCards.isAdmin')));
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = [];

        if (this.options.settings.view === PJQ.constants.timecards.view.BY_TIMECARD || this.options.settings.view === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD)
            includeColumns = ['assignedTo', 'projectId', 'projectName', 'projectAddress1', 'projectAddress2', 'projectCity', 'projectState', 'projectZip', 'projectCountry', 'projectBidsDue', 'projectStartDate', 'projectEndDate', 'contactAddress1', 'contactAddress2', 'contactCity', 'contactState', 'contactZip', 'contactCountry', 'contactPhone', 'contactCell', 'contactFax', 'contactEmail', 'contactUserTypeId'];

        includeColumns.push(...['date', 'notes', 'regularHours', 'overtimeHours', 'doubletimeHours', 'approvedOn']);

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.timecardsView && (this.options.timecardsView.selectionMode !== PJQ.constants.timecards.selectionMode.NONE)) {
                columns.push({
                    "columnData": '',
                    "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-timecards" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>',
                    "width": "40px",
                    "data": "null",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(this.renderTimeCardSelect, this)
                });
            }

            columns.push({
                "columnData": 'icons',
                "title": "",
                "width": "80px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let icons = [];

                    if (row.get('approvedOn')) {
                        icons.push("<i class='fas fa-check text-green fs-18 mr-2' title='Approved'></i>");
                    }

                    let exObj = row.get('externalObject');
                    if (exObj != null) {
                        icons.push(PJQ.helpers.erp.getERPBadge(exObj.status, exObj));
                    }

                    return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                }, this)
            });

        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        // Previously there was a contactName and companyName column that have combined into assignedTo.
        // To support these old columns we check if contactName or companyName are in the includedColumns.
        // If they are we render assignedTo. To prevent duplicate columns we need to check if it's already been rendered.
        let renderedAssignedTo = false;
        _.each(includeColumns, _.bind(function (columnName) {
            if(renderedAssignedTo && (columnName === 'assignedTo' || columnName === 'companyName' || columnName === 'contactName')){
                return;
            }

            switch (columnName) {
                case 'projectId':
                    columns.push({
                        "columnData": "projectId",
                        "data": "attributes.project.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "columnData": "projectName",
                        "data": "attributes.project.projectName",
                        "title": "Project",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return data;
                            }

                            return '<a href="#/projects/' + row.get('projectId') + '" data-id="' + row.id + '">' + data + '</a>';
                        }
                    });
                    break;
                case 'projectAddress1':
                    columns.push({
                        "columnData": "projectAddress1",
                        "data": "attributes.project.address1",
                        "title": (includeAllColumns ? 'Project ' : '') + "Address 1"
                    });
                    break;
                case 'projectAddress2':
                    columns.push({
                        "columnData": "projectAddress2",
                        "data": "attributes.project.address2",
                        "title": (includeAllColumns ? 'Project ' : '') + "Address 2"
                    });
                    break;
                case 'projectCity':
                    columns.push({
                        "columnData": "projectCity",
                        "data": "attributes.project.city",
                        "title": (includeAllColumns ? 'Project ' : '') + "City"
                    });
                    break;
                case 'projectState':
                    columns.push({
                        "columnData": "projectState",
                        "data": "attributes.project.state",
                        "title": (includeAllColumns ? 'Project ' : '') + "State"
                    });
                    break;
                case 'projectZip':
                    columns.push({
                        "columnData": "projectZip",
                        "data": "attributes.project.zip",
                        "title": (includeAllColumns ? 'Project ' : '') + "Zip"
                    });
                    break;
                case 'projectCountry':
                    columns.push({
                        "columnData": "projectCountry",
                        "data": "attributes.project.country",
                        "title": (includeAllColumns ? 'Project ' : '') + "Country"
                    });
                    break;
                case 'projectBidsDue':
                    columns.push({
                        "columnData": "projectBidsDue",
                        "data": "attributes.project.bidsDue",
                        "title": 'Bids Due',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('project').bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'projectStartDate':
                    columns.push({
                        "columnData": "projectStartDate",
                        "data": "attributes.project.startDate",
                        "title": 'Start Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('project').projectId > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('project').startDate), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'projectEndDate':
                    columns.push({
                        "columnData": "projectEndDate",
                        "data": "attributes.project.endDate",
                        "title": 'End Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('project').projectId > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('project').endDate), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'assignedTo':
                case 'contactName':
                case 'companyName':
                    renderedAssignedTo = true;
                    columns.push({
                        "columnData": "assignedTo",
                        "data": "",
                        "title": "Assigned To",
                        "render": (data, type, row) => {
                            if(row.get('equipmentId') != null && row.get('equipmentId') > 0){
                                return `<div class="fs-16">${row.get('equipment')?.name}</div><div class="fs-14">${row.get('equipment')?.type}</div>`;
                            } else {
                                return `<div class="fs-16">${row.get('contact')?.contactName}</div><div class="fs-14">${row.get('contact')?.companyName}</div>`
                            }
                        },
                    });
                    break;
                case 'contactAddress1':
                    columns.push({
                        "columnData": "contactAddress1",
                        "data": "attributes.contact.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'contactAddress2':
                    columns.push({
                        "columnData": "contactAddress2",
                        "data": "attributes.contact.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'contactCity':
                    columns.push({
                        "columnData": "contactCity",
                        "data": "attributes.contact.city",
                        "title": "City"
                    });
                    break;
                case 'contactState':
                    columns.push({
                        "columnData": "contactState",
                        "data": "attributes.contact.state",
                        "title": "State"
                    });
                    break;
                case 'contactZip':
                    columns.push({
                        "columnData": "contactZip",
                        "data": "attributes.contact.zip",
                        "title": "Zip"
                    });
                    break;
                case 'contactCountry':
                    columns.push({
                        "columnData": "contactCountry",
                        "data": "attributes.contact.country",
                        "title": "Country"
                    });
                    break;
                case 'contactPhone':
                    columns.push({
                        "columnData": "contactPhone",
                        "data": "attributes.contact.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('contact').phone ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('contact').phone) : 'N/A');

                            if (row.get('contact').phone !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'contactCell':
                    columns.push({
                        "columnData": "contactCell",
                        "data": "attributes.contact.cell",
                        "title": "Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('contact').cell ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('contact').cell) : 'N/A');

                            if (row.get('contact').cell !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'contactFax':
                    columns.push({
                        "columnData": "contactFax",
                        "data": "attributes.contact.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('contact').fax ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('contact').fax) : 'N/A');

                            if (row.get('contact').fax !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'contactEmail':
                    columns.push({
                        "columnData": "contactEmail",
                        "data": "attributes.contact.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('contact').email ? ('<a title="' + row.get('contact').email + '" style="color: inherit;" href="mailto:' + row.get('contact').email + '">' + row.get('contact').email + '</a>') : '');

                            if (row.get('contact').email !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('contact').email + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'contactUserTypeId':
                    columns.push({
                        "columnData": 'contactUserTypeId',
                        "title": 'Type',
                        "data": 'userTypeId',
                        "orderable": false,
                        "render": function (data, type, row) {
                            if(row.get('contact') == null){
                                return '';
                            }

                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(null), _.bind(function (userType) {
                                return row.get('contact').userTypeId === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'date':
                    columns.push({
                        "columnData": "date",
                        "data": "attributes.date",
                        "title": "Date",
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('date')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'notes':
                    columns.push({
                        "columnData": "notes",
                        "data": "attributes.notes",
                        "orderable": false,
                        "title": "Notes",
                        "width": "200px"
                    });
                    break;
                case 'regularHours':
                    columns.push({
                        "columnData": "regularHours",
                        "data": "attributes.regularHours",
                        "title": 'Reg. Hours',
                        "width": '120px',
                        "orderable": true,
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('regularHours'));
                        }
                    });
                    break;
                case 'overtimeHours':
                    columns.push({
                        "columnData": "overtimeHours",
                        "data": "attributes.overtimeHours",
                        "title": 'OT Hours',
                        "width": '120px',
                        "orderable": true,
                        "visible": this.options.timeCardSettings.get('enableOvertime'),
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('overtimeHours'));
                        }
                    });
                    break;
                case 'doubletimeHours':
                    columns.push({
                        "columnData": "doubletimeHours",
                        "data": "attributes.doubletimeHours",
                        "title": 'DT Hours',
                        "width": '120px',
                        "orderable": true,
                        "visible": this.options.timeCardSettings.get('enableDoubletime'),
                        "render": (data, type, row) => {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('doubletimeHours'));
                        }
                    });
                    break;
                case 'approvedOn':
                    columns.push({
                        "columnData": "approvedOn",
                        "data": "attributes.approvedOn",
                        "title": "Approved On",
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            return row.get('approvedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('approvedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false) : '';
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    html += '<div class="' + (this.options.view === PJQ.constants.timecards.view.BY_TIMECARD || this.options.view === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD ? 'show-on-row-hover' : '') + '">';

                    if (PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin')))
                        html += row.get('approvedOn') ? '<button type="button" class="btn btn-secondary unapprove-time-card" title="Un-Approve Time Card"><i class="fal fa-calendar-times"></i></button>' : '<button type="button" class="btn btn-secondary approve-time-card" title="Approve Time Card"><i class="fal fa-calendar-check"></i></button>';

                    html += '<button type="button" class="btn btn-info view-time-card ml-1" title="View Time Card"><i class="fal fa-arrow-alt-from-left"></i></button>';

                    if (!row.get('approvedOn') && (this.options.permissions.hasPermission('timeCards.isAdmin')))
                        html += '<button type="button" class="btn btn-danger delete-time-card ml-1" title="Delete Time Card"><i class="fal fa-trash"></i></button>';

                    html += '</div>';
                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "140px",
                "className": "text-center"
            });
        }

        return columns;
    },
    selectAll: function (e) {
        let isChecked = $(e.currentTarget).prop('checked');

        if (this.options.view === PJQ.constants.timecards.view.BY_TIMECARD) {
            if (isChecked) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'timecards'
                        },
                        {
                            endpoint: 'ids'
                        }
                    ], [
                        {
                            parameter: 'searchFor',
                            value: this.options.timecardsView.$('.input-search').val()
                        },
                        {
                            parameter: 'startDate',
                            value: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
                        },
                        {
                            parameter: 'endDate',
                            value: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
                        }
                    ]),
                    isAPIv2: true
                }).get().done(_.bind(function (response) {
                    this.options.timecardsView.addSelectedTimeCards(response.timeCardIds);
                }, this));
            } else {
                this.options.timecardsView.selectedTimeCards = [];
            }
        } else {
            let timeCardIds = [];
            this.dataTable.rows().data().each(_.bind(function (data) {
                timeCardIds.push(data.get('timeCardId'));
            }));

            if (isChecked)
                this.options.timecardsView.addSelectedTimeCards(timeCardIds);
            else
                this.options.timecardsView.removeSelectedTimeCards(timeCardIds);
        }

        this.dataTable.rows().invalidate().draw(false);
    },
    selectTimeCard: function (e) {
        let isChecked = $(e.currentTarget).prop('checked'), row = this.getRow($(e.currentTarget).closest('tr'));

        if (isChecked)
            this.options.timecardsView.addSelectedTimeCards([row.data().get('timeCardId')]);
        else
            this.options.timecardsView.removeSelectedTimeCards([row.data().get('timeCardId')]);
    },
    renderTimeCardSelect: function (data, type, row) {
        let isSelected = (this.options.timecardsView.selectedTimeCards.indexOf(row.get('timeCardId')) !== -1);

        let html = '<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected ? ' checked ' : '') + ' class="select-timecard" />' +
            '<div class="state p-primary"><label class="wd-0">&nbsp;</label></div>' +
            '</div></div>';

        return (html);
    },
    captureSignature: function (callback) {
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_TIMECARDS_SIGNATURE)) {
            new PJQ.views.signatures.SignatureSubmitModal({
                headerSubText: "Sign off on your time card changes",
                onSubmit: _.bind(function (signature, cb) {
                    cb();
                    callback(signature ? signature : "");
                }, this)
            });
        } else {
            callback(null);
        }
    },
    viewTimeCard: function (row) {
        let timeCard = new PJQ.models.timecards.TimeCard({timeCardId: row.data().get('timeCardId')}, {
            context: row.data().get('context')
        });

        timeCard.fetch({
            success: _.bind(function () {
                this.originalTimeCard = {
                    regularHours: timeCard.get('regularHours'),
                    overtimeHours: timeCard.get('overtimeHours'),
                    doubletimeHours: timeCard.get('doubletimeHours')
                };

                let editModal = new PJQ.views.timecards.TimeCardDetailsModal({
                    project: this.options.project,
                    settings: this.options.timeCardSettings,
                    permissions: PJQ.app.session.project ? PJQ.app.session.project.permissions : PJQ.app.session.systemPermissions,
                    model: timeCard,
                    onSave: _.bind(function () {
                        let fnSave = _.bind(function (signature) {
                            new PJQ.ajax.Request({
                                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'timecards',
                                    },
                                    {
                                        endpoint: 'batch'
                                    }
                                ]),
                                data: {
                                    rows: [timeCard],
                                    signature: signature
                                },
                                isAPIv2: true
                            }).post().success(_.bind(function (data) {
                                row.data().set('notes', timeCard.get('notes'));
                                row.data().set('regularHours', timeCard.get('regularHours'));
                                row.data().set('overtimeHours', timeCard.get('overtimeHours'));
                                row.data().set('doubletimeHours', timeCard.get('doubletimeHours'));
                                row.data().set('approvedOn', timeCard.get('approvedOn'));

                                row.invalidate().draw(false);
                                let offsets = {
                                    regularHours: timeCard.get('regularHours') - this.originalTimeCard.regularHours,
                                    overtimeHours: timeCard.get('overtimeHours') - this.originalTimeCard.overtimeHours,
                                    doubletimeHours: timeCard.get('doubletimeHours') - this.originalTimeCard.doubletimeHours
                                };
                                this.updateParentRows(offsets, row);

                                PJQ.notifications.notify.successNotify({
                                    message: 'Time Card saved successfully'
                                });

                                if(typeof this.options.onChange === 'function'){
                                    this.options.onChange(timeCard);
                                }
                            }, this));
                        }, this);

                        if (timeCard.get('id') === -PJQ.app.session.user.id) {
                            this.captureSignature(_.bind(function (signature) {
                                fnSave(signature);
                                editModal.removeModal();
                            }, this));
                        } else {
                            fnSave();
                            editModal.removeModal();
                        }
                        return false;
                    }, this),
                    onDelete: _.bind(function () {
                        this.deleteTimeCard(row, true);

                        if(typeof this.options.onChange === 'function'){
                            this.options.onChange(timeCard);
                        }
                    }, this)
                });
            }, this),
        });
    },
    viewTimeCardClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.viewTimeCard(row);
    },
    updateParentRows: function (offsets, row) {
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD ||
            this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD) {
            let parentTR = this.options.parentDataTable ? $(row.node()).parent().closest('tr').prev() : null,
                parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null;

            if (parentRow !== null) {
                parentRow.data().set('regularHours', parentRow.data().get('regularHours') + offsets.regularHours);
                parentRow.data().set('overtimeHours', parentRow.data().get('overtimeHours') + offsets.overtimeHours);
                parentRow.data().set('doubletimeHours', parentRow.data().get('doubletimeHours') + offsets.doubletimeHours);
                parentRow.invalidate().draw(false);

                let grandParentTR = $(parentRow.node()).parent().closest('tr').prev(),
                    grandParentRow = this.options.parentDataTable.options.parentDataTable.getRow(grandParentTR);
                grandParentRow.data().set('regularHours', grandParentRow.data().get('regularHours') + offsets.regularHours);
                grandParentRow.data().set('overtimeHours', grandParentRow.data().get('overtimeHours') + offsets.overtimeHours);
                grandParentRow.data().set('doubletimeHours', grandParentRow.data().get('doubletimeHours') + offsets.doubletimeHours);
                grandParentTR.find('.regularHours').text(PJQ.helpers.timecards.getFormattedTime(grandParentRow.data().get('regularHours')));
                grandParentTR.find('.overtimeHours').text(PJQ.helpers.timecards.getFormattedTime(grandParentRow.data().get('overtimeHours')));
                grandParentTR.find('.doubletimeHours').text(PJQ.helpers.timecards.getFormattedTime(grandParentRow.data().get('doubletimeHours')));
            }
        }
    },
    deleteTimeCard: function (row, force) {
        let fn = _.bind(function () {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'timecards',
                        value: row.data().get('timeCardId')
                    }
                ]),
                isAPIv2: true
            }).delete().done(_.bind(function (response) {
                let timeCard = row.data(),
                    offsets = {
                    regularHours: -timeCard.get('regularHours'),
                    overtimeHours: -timeCard.get('overtimeHours'),
                    doubletimeHours: -timeCard.get('doubletimeHours'),
                };
                this.updateParentRows(offsets, row);
                row.remove().draw();

                if(typeof this.options.onChange === 'function'){
                    this.options.onChange(timeCard);
                }
            }, this));
        }, this);

        if (force)
            fn();
        else {
            new PJQ.views.modals.DeleteCancel({
                header: "Delete Time Card",
                body: "Do you want to delete this Time Card?",
                onDelete: _.bind(function () {
                    fn();
                }, this)
            });
        }
    },
    deleteTimeCardClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteTimeCard(row);
    },
    approveTimeCardClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.approveTimeCard(row);
    },
    approveTimeCard: function (row) {
        let timeCard = row.data(),
            approve = timeCard.get('approvedOn') == null,
            action = (approve ? 'Approve' : 'Un-Approve');
        if (typeof this.options.onApprove === 'function') {
            new PJQ.views.modals.YesNo({
                header: action + " Time Card",
                body: "Are you sure you want to " + action.toLowerCase() + " this time card?",
                onYes: _.bind(function () {
                    this.options.onApprove(row.data(), approve, () => {
                        row.invalidate().draw();
                    });
                }, this)
            });
        }
    }
});

// Data Entry Datatables
PJQ.views.timecards.TimeCardDataEntryTable = PJQ.views.timecards.BaseDataTable.extend({
    defaults: {
        isHideSearch: true,
        order: [],
        dom: 't',
        pageLength: 5,
        language: {
            zeroRecords: "No Time Cards to edit"
        },
        drawCallback: _.bind(function (settings) {
            PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-regular-hours'), 2);
            PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-overtime-hours'), 2);
            PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-doubletime-hours'), 2);
        }, this),
    },
    events: {
        'click i.timecard-dataentry-toggle-row': 'childRowToggle',
        'change .input-notes': 'valueChanged',
        'change .input-regular-hours': 'valueChanged',
        'change .input-overtime-hours': 'valueChanged',
        'change .input-doubletime-hours': 'valueChanged',
        'click .delete-time-card': 'deleteTimeCard'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [];

        if (this.options.groupByColumn === PJQ.constants.timecards.timeCardGroupBy.DATE) {
            columns.push({
                "data": "attributes.contact.companyName",
                "title": "Company",
                "orderable": false
            });

            columns.push({
                "data": "attributes.contact.contactName",
                "title": "Contact",
                "orderable": false
            });
        }

        if (this.options.groupByColumn === PJQ.constants.timecards.timeCardGroupBy.CONTACT) {
            columns.push({
                    "data": "attributes.date",
                    "title": "Date",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(row.get('date'), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD, false);
                    }, this)
                },
            );

        }

        columns.push({
            "title": "Notes",
            "orderable": false,
            "width": '200px',
            "render": _.bind(function (data, type, row) {
                if (!row.get('approvedOn')) {
                    return '<textarea type="text" class="form-control input-notes" data-field="notes">' + row.get('notes') + '</textarea>';
                } else {
                    return row.get('notes');
                }
            }, this)
        });

        columns.push({
            "title": "Reg.",
            "width": '50px',
            "orderable": false,
            "render": _.bind(function (data, type, row) {
                let value = PJQ.helpers.formatHelpers.formatCurrency(row.get('regularHours'), 2, false);
                if (!row.get('approvedOn')) {
                    return '<input type="text" class="form-control input-regular-hours" data-field="regularHours" value="' + value + '">';
                } else {
                    return value;
                }
            }, this)
        });
        columns.push({
            "title": "OT",
            "width": '50px',
            "orderable": false,
            "render": _.bind(function (data, type, row) {
                let value = PJQ.helpers.formatHelpers.formatCurrency(row.get('overtimeHours'), 2, false);
                if (!row.get('approvedOn')) {
                    return '<input type="text" class="form-control input-overtime-hours" data-field="overtimeHours" value="' + value + '">';
                } else {
                    return value;
                }
            }, this)
        });
        columns.push({
            "title": "DT",
            "width": '50px',
            "orderable": false,
            "render": _.bind(function (data, type, row) {
                let value = PJQ.helpers.formatHelpers.formatCurrency(row.get('doubletimeHours'), 2, false);
                if (!row.get('approvedOn')) {
                    return '<input type="text" class="form-control input-doubletime-hours" data-field="doubletimeHours" value="' + value + '">';
                } else {
                    return value;
                }
            }, this)
        });

        columns.push({
            "title": '',
            "render": _.bind(function (data, type, row) {
                let html = '';
                html += '<div class="show-on-row-hover">';

                if (!row.get('approvedOn') &&
                    ((PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canAdd') || this.options.permissions.hasPermission('timeCards.isAdmin'))) ||
                        (PJQ.app.session.contact && this.options.permissions.hasPermission('timeCards.canAdd')))
                ) {
                    if (!PJQ.app.session.contact || !row.get('timeCardId'))
                        html += '<button type="button" class="btn btn-danger delete-time-card ml-1" title="Delete Time Card"><i class="fal fa-trash"></i></button>';
                }
                html += '</div>';
                return html;
            }, this),
            "orderable": false,
            "searchable": false,
            "width": "140px",
            "className": "text-center"
        });

        if (!includeAllColumns) {

        }

        return columns;
    },
    valueChanged: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr')[0]),
            fieldName = $(e.currentTarget).data('field'),
            value = ($(e.currentTarget).hasClass('input-notes')) ? $(e.currentTarget).val() : parseInt(parseFloat($(e.currentTarget).val()) * 100);

        row.data().set(fieldName, value);

        if (fieldName !== 'notes')
            $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatCurrency(row.data().get(fieldName), 2, false));
    },
    deleteTimeCard: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr')[0]);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Time Card",
            body: "Do you want to delete this Time Card?" + (this.options.timecardsModal.options.timeCard == null && !row.data().isNew() ? '<br /><br /><b>Note:</b> You will need to click Save after finishing all editing in order to save your changes.' : ''),
            onDelete: _.bind(function () {

                if (this.options.timecardsModal.options.timeCard === null) {
                    if (row.data().isNew()) {
                        this.options.timecardsModal.model.remove([row.data()]);
                        row.remove().draw();
                    } else {
                        row.data().set('deletedOn', new Date());
                        row.remove().draw();
                    }
                } else {
                    row.data().set('deletedOn', new Date());
                    this.options.timecardsModal.saveTimeCards(null, true);
                }
            }, this)
        });
    }
});
PJQ.views.timecards.TimeCardDetailsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-manage-timecard'),
        subTemplates: {
            lineItems: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-line-items')
        },
        minWidth: '800px',
        onSave: _.noop(),
        model: null,
        canApprove: false,
        canDelete: false
    },
    events: {
        'click .timecard-save': 'saveClicked',
        'click .timecard-delete': 'deleteClicked',
        'click .timecard-approve': 'approveClicked',
        'keyup .overtime-hours, .regular-hours, .doubletime-hours': 'hoursChanged',
        'click .btn-view-locations': 'viewTimecardLocations',
        'click .btn-manage-production-quantities': 'manageProductionQuantities'
    },
    beforeModalCreated: function () {
        if (this.model != null && (this.options.project == null || this.options.project.id !== this.model.get('project').id)) {
            this.options.project = new PJQ.models.projects.Project(this.model.get('project'));
        }

        let fnFetch = _.bind(function () {
            this.isFetched = true;
            this.render();
        }, this)

        if(this.options.project.id <= 0) {
            this.options.permissions = PJQ.app.session.systemPermissions;
            fnFetch();
        } else if (!this.options.project.isFetched) {
            this.options.project.fetch({
                success: _.bind(function () {
                    this.options.permissions = this.options.project.permissions
                    fnFetch();
                }, this)
            })
        } else {
            this.options.permissions = this.options.project.permissions;
            fnFetch();
        }
    },
    beforeRender: function () {
        if (this.isFetched) {
            this.options.canApprove = this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin');
            this.options.canDelete = this.model.get('approvedOn') == null && this.options.permissions.hasPermission('timeCards.isAdmin');
            this.options.canEdit = this.model.get('approvedOn') == null && this.options.permissions.hasPermission('timeCards.canAdd');
            this.options.canViewQuantities = this.options.permissions.hasPermission('productionQuantities.canView');
            this.options.enableOvertime = this.options.settings.get('enableOvertime');
            this.options.enableDoubletime = this.options.settings.get('enableDoubletime');
            this.options.enableLineItems = this.options.settings.get('enableLineItems');
            this.options.enableClockIn = this.options.settings.get('enableClockIn');
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            settings: this.options.settings,
            canEdit: this.options.canEdit,
            canApprove: this.options.canApprove,
            canDelete: this.options.canDelete,
            canViewQuantities: this.options.canViewQuantities,
            enableOvertime: this.options.enableOvertime,
            enableDoubletime: this.options.enableDoubletime,
            enableLineItems: this.options.enableLineItems,
            enableClockIn: this.options.enableClockIn,
            canViewLocationMap: (this.model.get('latitudeIn') && this.model.get('longitudeIn')) || (this.model.get('latitudeOut') && this.model.get('longitudeOut'))
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'textarea'
            ]
        });

        if (this.options.enableLineItems) {
            this.renderLineItems();
        } else {
            this.$('.regular-hours').focus().select();
        }

        this.$('.erp-badge').html(PJQ.helpers.erp.getERPBadge(this.model.erpSyncStatus(), this.model.get('externalObject')));

        this.renderInputs();
        this.renderTotals();
    },
    renderLineItems: function () {
        new PJQ.views.timecards.LineItemsView({
            el: this.$('.line-items-outer'),
            model: this.model,
            project: this.options.project,
            settings: this.options.settings,
            onLineItemChanged: () => {
                this.renderTotals();
            }
        });
    },
    renderInputs: function () {
        this.$('.regular-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('regularHours')));
        this.$('.overtime-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('overtimeHours')));
        this.$('.doubletime-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('doubletimeHours')));
        PJQ.helpers.inputHelpers.inputMaskHours(this.$('.input-hours'));

        if(this.options.enableClockIn) {
            new PJQ.inputs.Datepicker({
                el: this.$('.time-in'),
                isTimeOnly: true,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.model.get('timeIn')
                },
                onChange: (value) => {
                    this.model.set('timeIn', value);
                    this.renderTotals();
                }
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.time-out'),
                isTimeOnly: true,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.model.get('timeOut')
                },
                onChange: (value) => {
                    this.model.set('timeOut', value);
                    this.renderTotals();
                }
            });
        }
    },
    renderTotals: function () {
        if(!this.options.enableClockIn) {
            this.$('.total-regular-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('regularHours')));
        } else {
            let minutes = 0;
            if(this.options.enableLineItems){
                _.each(this.model.lineItems.models, function(lineItem){
                    if(lineItem.get('timeIn') != null && lineItem.get('timeOut') != null) {
                        minutes += PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(lineItem.get('timeOut')), new Date(lineItem.get('timeIn')));
                    }
                });
            }
            else if(this.model.get('timeIn') != null && this.model.get('timeOut') != null){
                minutes = PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(this.model.get('timeOut')), new Date(this.model.get('timeIn')));
            }
            this.$('.total-regular-hours').text(minutes > 0 ? PJQ.helpers.formatHelpers.minutesToHHMM(minutes) : '00:00');
        }

        this.$('.total-overtime-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('overtimeHours')));
        this.$('.total-doubletime-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('doubletimeHours')));
    },
    hoursChanged: function (e) {
        let $target = $(e.currentTarget),
            type = $target.data('type'),
            minutes = PJQ.helpers.formatHelpers.minutesFromHHMM($target.val());

        this.model.set(type, minutes);
        this.renderTotals();
    },
    saveClicked: function () {
        this.model.set('lineItems', this.model.lineItems.toJSON());

        if (typeof this.options.onSave === 'function') {
            if (this.options.onSave() !== false) {
                this.removeModal();
            }
        } else {
            this.removeModal();
        }
    },
    approveClicked: function () {
        let isApproved = this.model.get('approvedOn') != null;
        new PJQ.views.modals.YesNo({
            header: "Confirm " + (isApproved ? 'Un-Approval' : 'Approval'),
            body: "Are you sure you want to " + (isApproved ? 'un-approve' : 'approve') + " this Time Card?",
            onYes: _.bind(function () {
                if (this.model.get('approvedOn')) {
                    this.model.set('approvedOn', null);
                    this.$('.timecard-approve').text('Approve');
                    this.render();
                } else {
                    this.model.set('approvedOn', new Date());
                    this.saveClicked();
                }
            }, this)
        });
    },
    deleteClicked: function () {
        new PJQ.views.modals.YesNo({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Time Card?",
            onYes: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete();
                }

                this.removeModal();
            }, this)
        });
    },
    viewTimecardLocations: function () {
        new PJQ.views.timecards.TimeCardLocationMapModal({
            model: this.model
        });
    },
    manageProductionQuantities: function() {
        new PJQ.views.productionQuantities.InstalledQuantitiesAddModal({
            project: this.options.project,
            timeCardId: this.model.id,
            collection: this.model.installedQuantities,
            onSave: (quantities) => {
                this.model.installedQuantities.remove(
                    this.model.installedQuantities.filter((model) => model.isNew() || model.get('delete'))
                );

                this.model.installedQuantities.add(quantities);
            }
        });
    }
});
PJQ.inputs.timecards = {}
PJQ.inputs.timecards.TimeCardEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-editor-input'),
        isReadOnly: false,
        onChange: _.noop(),
        onNextField: _.noop(),
        model: null
    },
    events: {
        'click button.edit': 'showDetails'
    },
    beforeFirstRender: function () {
        this.model = this.options.model;

        if (this.model.get('approvedOn') || !(PJQ.app.session.hasPermission('timeCards.canAdd') || (PJQ.app.session.project && PJQ.app.session.project.hasPermission('timeCards.canAdd'))))
            this.options.isReadOnly = true;

    },
    renderData: function () {
        return {
            model: this.model,
            isReadOnly: this.options.isReadOnly
        };
    },
    afterRender: function () {

        this.$('input.hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {

            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.hours').val()) == 2) {
                this.$('input.minutes').focus();
            }

        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.hours').select();
        }, this));

        this.$('input.minutes').inputmask('59', {
            positionCaretOnClick: 'select',
            definitions: {
                "5": {
                    validator: "[012345]"
                }
            },
            placeholder: ''
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.minutes').val()) == 2) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.model);
                }
            }
        }, this)).off("keydown.tei").on("keydown.tei", _.bind(function (e) {
            if (e.which == 9) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.model);
                }

                e.preventDefault();
            }
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.minutes').select();
        }, this));

        let totalMinutes = this.model.getTotalTime();
        let hours = parseInt(totalMinutes / 60);
        let minutes = totalMinutes % 60;

        this.$('input.hours').val(hours);
        this.$('input.minutes').val(minutes);
    },
    showDetails: function () {
        new PJQ.views.timecards.TimeCardDetailsModal({
            settings: this.options.settings,
            project: this.options.project,
            model: this.model,
            onSave: _.bind(function () {
                let totalMinutes = this.model.getTotalTime();
                let hours = parseInt(totalMinutes / 60);
                let minutes = totalMinutes % 60;

                this.$('input.hours').val(hours);
                this.$('input.minutes').val(minutes);

                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(this.model);
                }
            }, this)
        });
    },
    valueChanged: function (e) {
        let hours = 0, minutes = 0;

        if (this.$('input.hours').val())
            hours = parseInt(this.$('input.hours').val());

        if (this.$('input.minutes').val())
            minutes = parseInt(this.$('input.minutes').val());

        this.model.set('regularHours', (hours * 60) + minutes);
        this.model.set('overtimeHours', 0);
        this.model.set('doubletimeHours', 0);

        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    },
});

PJQ.inputs.timecards.TimeCardWeekEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-week-input'),
        isReadOnly: false,
        onChange: _.noop(),
        onDelete: _.noop(),
        row: null,
        startDate: null
    },
    events: {
        'click .delete-time-card-week': 'deleteWeek'
    },
    beforeFirstRender: function () {

    },
    renderData: function () {
        return {
            project: this.options.row.project,
            canDelete: _.size(_.filter(this.options.row.models, function (model) {
                return model.get('approvedOn') == null;
            })) > 0 && (PJQ.app.session.hasPermission('timeCards.isAdmin') || (PJQ.app.session.project && PJQ.app.session.project.hasPermission('timeCards.isAdmin')))
        };
    },
    afterRender: function () {
        this.editors = [];

        // iterate through the days, find model for that day and create the control
        for (let i = 0; i < 7; i++) {
            let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.options.startDate, i);

            _.each(this.options.row.models, _.bind(function (timecard) {
                if (timecard.get('date').getTime() == PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)).getTime()) {
                    this.editors.push(new PJQ.inputs.timecards.TimeCardEditor({
                        el: this.$('div.time-card-day[data-day-column="' + i + '"] div.timecard-editor'),
                        settings: this.options.settings,
                        model: timecard,
                        project: this.options.project,
                        onChange: _.bind(function () {
                            this.calculateWeekTotal();
                        }, this),
                        onNextField: _.bind(function () {
                            if (i < 6) {
                                this.editors[i + 1].$el.find('input.hours').focus();
                            }
                        }, this)
                    }));
                }
            }, this));
        }

        this.calculateWeekTotal();
    },
    getTotalTimeForDate: function (date) {
        let totalMinutes = 0;
        _.each(this.options.row.models, _.bind(function (timecard) {
            if (!timecard.get('deletedOn') && timecard.get('date').getTime() == PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)).getTime())
                totalMinutes += timecard.getTotalTime();
        }, this));

        return totalMinutes;
    },
    calculateWeekTotal: function () {
        let totalMinutes = 0;
        _.each(this.options.row.models, _.bind(function (timecard) {
            if (!timecard.get('deletedOn'))
                totalMinutes += timecard.getTotalTime();
        }, this));

        this.$('.time-card-total').text(PJQ.helpers.timecards.getFormattedTime(totalMinutes));

        if (typeof this.options.onChange === 'function') {
            this.options.onChange();
        }
    },
    hasChanges: function () {
        for (let i = 0; i < _.size(this.options.row.models); i++) {
            let timecard = this.options.row.models[i];
            if (timecard.get('deletedOn') || (!timecard.isNew() && timecard.isDirty)
                || (timecard.isNew() && (_.size(timecard.get('notes')) > 0 || timecard.getTotalTime() > 0))) {
                return true;
            }
        }
        return false;
    },
    isWeekNewAndEmpty: function () {
        let totalMinutes = 0, totalNotes = 0;
        _.each(this.options.row.models, _.bind(function (timecard) {
            if (!timecard.get('deletedOn') && timecard.isNew()) {
                totalMinutes += timecard.getTotalTime();
                totalNotes += _.size(timecard.get('notes'));
            } else {
                // found a not new one
                totalMinutes += 1;
            }
        }, this));

        return (totalMinutes + totalNotes === 0);
    },
    deleteWeek: function () {
        new PJQ.views.modals.YesNo({
            header: "Delete Time Cards",
            body: "Do you want delete time cards for this week for " + this.options.row.project.projectName + "?",
            onYes: _.bind(function () {
                _.each(this.options.row.models, _.bind(function (timecard) {
                    if (!timecard.get('approvedOn'))
                        timecard.set({
                            delete: true,
                            deletedOn: new Date()
                        });
                }, this));

                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete();
                }
            }, this)
        });
    }
});

PJQ.helpers.timecards = {}
PJQ.helpers.timecards.getFormattedTime = function (input) {
    let totalMinutes = input,
        hours = parseInt(totalMinutes / 60),
        minutes = totalMinutes % 60;

    return hours + ':' + ((minutes < 10) ? '0' : '') + minutes;
};

PJQ.inputs.timecards.TimeCardGroupEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-group-editor-input'),
        isReadOnly: false,
        onChange: _.noop(),
        onDelete: _.noop(),
        onNextField: _.noop(),
        model: null
    },
    events: {
        'click .delete-group': 'deleteGroup'
    },
    beforeFirstRender: function () {

    },
    renderData: function () {
        return {
            isReadOnly: this.options.isReadOnly,
            model: this.options.model
        };
    },
    afterRender: function () {
        this.$('input.group-regular-hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-regular-hours').val()) == 2)
                this.$('input.group-regular-minutes').focus();
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.group-regular-hours').select();
        }, this));

        this.$('input.group-overtime-hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-overtime-hours').val()) == 2)
                this.$('input.group-overtime-minutes').focus();
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.group-overtime-hours').select();
        }, this));

        this.$('input.group-doubletime-hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-doubletime-hours').val()) == 2)
                this.$('input.group-doubletime-minutes').focus();
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.group-doubletime-hours').select();
        }, this));

        this.$('input.group-regular-minutes, input.group-overtime-minutes, input.group-doubletime-minutes').inputmask('59', {
            definitions: {
                "5": {
                    validator: "[012345]"
                }
            },
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", function () {
            $(this).select();
        });

        this.$('input.group-regular-minutes').off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-regular-minutes').val()) == 2)
                this.$('input.group-overtime-hours').focus();
        }, this));

        this.$('input.group-overtime-minutes').off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-overtime-minutes').val()) == 2)
                this.$('input.group-doubletime-hours').focus();
        }, this));

        this.$('input.group-doubletime-minutes').off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-doubletime-minutes').val()) == 2) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.options.model);
                }
            }
        }, this)).off("keydown.tei").on("keydown.tei", _.bind(function (e) {
            if (e.which == 9) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.options.model);
                }
                e.preventDefault();
            }
        }, this));

        this.$('input.group-regular-hours').val((parseInt(this.options.model.get('regularHours') / 60)).toString().padStart(2, '0'));
        this.$('input.group-regular-minutes').val((parseInt(this.options.model.get('regularHours') % 60)).toString().padStart(2, '0'));
        this.$('input.group-overtime-hours').val((parseInt(this.options.model.get('overtimeHours') / 60)).toString().padStart(2, '0'));
        this.$('input.group-overtime-minutes').val((parseInt(this.options.model.get('overtimeHours') % 60)).toString().padStart(2, '0'));
        this.$('input.group-doubletime-hours').val((parseInt(this.options.model.get('doubletimeHours') / 60)).toString().padStart(2, '0'));
        this.$('input.group-doubletime-minutes').val((parseInt(this.options.model.get('doubletimeHours') % 60)).toString().padStart(2, '0'));

        this.$('.group-regular-hours').focus();
    },
    valueChanged: function () {
        if (typeof this.options.onChange == 'function')
            this.options.onChange();
    },
    getValues: function () {
        let regularHours = 0, overtimeHours = 0, doubletimeHours = 0;

        let hours = 0, minutes = 0;

        if (this.$('input.group-regular-hours').val())
            hours = parseInt(this.$('input.group-regular-hours').val());

        if (this.$('input.group-regular-minutes').val())
            minutes = parseInt(this.$('input.group-regular-minutes').val());

        regularHours = (hours * 60) + minutes;

        hours = 0, minutes = 0;

        if (this.$('input.group-overtime-hours').val())
            hours = parseInt(this.$('input.group-overtime-hours').val());

        if (this.$('input.group-overtime-minutes').val())
            minutes = parseInt(this.$('input.group-overtime-minutes').val());

        overtimeHours = (hours * 60) + minutes;

        hours = 0, minutes = 0;

        if (this.$('input.group-doubletime-hours').val())
            hours = parseInt(this.$('input.group-doubletime-hours').val());

        if (this.$('input.group-doubletime-minutes').val())
            minutes = parseInt(this.$('input.group-doubletime-minutes').val());

        doubletimeHours = (hours * 60) + minutes;

        return {
            regularHours: regularHours,
            overtimeHours: overtimeHours,
            doubletimeHours: doubletimeHours
        };
    },
    deleteGroup: function () {
        new PJQ.views.modals.YesNo({
            header: "Delete Trade",
            body: "Do you want delete time for " + this.options.model.get('group').groupName + "?",
            onYes: _.bind(function () {
                this.options.model.set('deletedOn', new Date());

                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.options.model);
                }
            }, this)
        });
    }
});
PJQ.models.timecards = {};

PJQ.models.timecards.TimeCard = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'timeCardId',
    endpoint: function () {
        let params = [];
        if (this.options.context)
            params.push({
                parameter: 'context',
                value: this.options.context
            });
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards',
                value: this.get('timeCardId')
            }
        ], params);
    },
    parse: function(model) {
        if (!model)
            return;

        if (model.date)
            model.date = PJQ.helpers.dateHelpers.parseDateString(model.date, false);

        if (model.groups)
            model.groups = new PJQ.collections.timecards.TimeCardGroups(model.groups.models ? model.groups.models : model.groups);

        this.lineItems = new PJQ.collections.timecards.TimeCardLineItems(model.lineItems);
        this.installedQuantities = new PJQ.collections.productionQuantities.InstalledQuantities(model.installedQuantities);

        return model;
    },
    getTotalTime: function() {
        return this.get('regularHours')+this.get('doubletimeHours')+this.get('overtimeHours');
    },
    beforeSave: function () {
        this.set({
            lineItems: this.lineItems.toJSON()
        });
    },
    erpSyncStatus: function () {
        let exObj = this.get('externalObject');

        return exObj != null && typeof exObj.status === 'number' ? exObj.status : 0;
    },
});

PJQ.models.timecards.TimeCardCategory = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards',
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'categories',
                value: this.get('timeCardCategoryId')
            }
        ]);
    },
    idAttribute: 'timeCardCategoryId'
});

PJQ.models.timecards.TimeCardGroup = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'timeCardGroupId'
});

PJQ.models.timecards.TimeCardLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

// Settings
PJQ.models.timecards.TimeCardUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.timecards.TimeCardSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [
            {
                parameter: 'contactId',
                value: this.options.contact ? this.options.contact.get('contactId') : 0
            },
            {
                parameter: 'projectId',
                value: this.options.project ? this.options.project.get('projectId') : 0
            }
        ];

        if(this.options.project){
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'timecards'
                },
                {
                    endpoint: 'settings'
                }
            ], params);
        }
        else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'timecards'
                },
                {
                    endpoint: 'settings'
                }
            ], params);
        }
    }
});

PJQ.models.timecards.Crew = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        if(this.options.projectId){
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'crews',
                    value: this.id > 0 ? this.id : null
                }
            ]);
        }
        else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'crews',
                    value: this.id > 0 ? this.id : null
                }
            ]);
        }
    },
    parse: function (model) {
        if (!model)
            return model;

        this.workers = new PJQ.collections.timecards.CrewWorkers(model.workers);

        return model;
    },
    beforeSave: function() {
        this.set({
            workers: this.workers?.toJSON()
        });
    }
});

PJQ.models.timecards.CrewWorker = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    parse: function (model) {
        if (!model)
            return model;

        if(model.person){
            this.person = new PJQ.models.BaseModel(model.person);
        }

        return model;
    },
});

PJQ.models.timecards.Equipment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        if(this.options.projectId){
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'equipment',
                    value: this.id > 0 ? this.id : null
                }
            ]);
        }
        else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'equipment',
                    value: this.id > 0 ? this.id : null
                }
            ]);
        }
    }
});

PJQ.collections.timecards = {};

PJQ.collections.timecards.TimeCardCategories = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCardCategory,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'categories'
            }
        ], params);
    }
});

PJQ.collections.timecards.TimeCards = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCard,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            }
        ], params);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            if (data) {
                this.totalRows = data.totalRows;
                return data.rows;
            }
        }
        return null;
    },
    getTimeCard: function(id, date, isEquipment = false) {
        let targetDate = PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD);

        return _.find(this.models, model => {
            let modelDate = PJQ.helpers.dateHelpers.getDateString(model.get('date'), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD);
            let isDeleted = !!model.get('deletedOn');

            if (modelDate !== targetDate || isDeleted)
                return false;

            return isEquipment ? model.get('equipmentId') === id : model.get('contact')?.id === id;
        }) || null;
    }
});

PJQ.collections.timecards.TimeCardGroups = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCardGroup
});

PJQ.collections.timecards.TimeCardLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCardLineItem
});

PJQ.collections.timecards.TimeCardContextProjects = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [
            {
                parameter: 'startDate',
                value: this.options.startDate
            },
            {
                parameter: 'endDate',
                value: this.options.endDate
            }
        ];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'context',
                value: this.options.id
            },
            {
                endpoint: 'projects'
            }
        ], params);
    }
});

PJQ.collections.timecards.TimeCardProjects = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'projects'
            }
        ], params);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            if (data) {
                this.totalRows = data.totalRows;
                return data.rows;
            }
        }
        return null;
    }
});

PJQ.collections.timecards.TimeCardContacts = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'contacts'
            }
        ], params);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            if (data) {
                this.totalRows = data.totalRows;
                return data.rows;
            }
        }
        return null;
    }
});

PJQ.collections.timecards.Crews = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.Crew,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push({
            endpoint: 'crews'
        });

        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    _prepareModel: function(attrs, options) {
        options = options || {};
        options.projectId = this.options.projectId;
        return Backbone.Collection.prototype._prepareModel.call(this, attrs, options);
    },
    batchUpdate: function(addIds, deleteIds, callback) {
        if(!this.options.projectId)
            return;

        new PJQ.ajax.Request({
            endpoint: `${this.endpoint()}/batch`,
            data: {
                addIds: addIds,
                deleteIds: deleteIds
            },
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    }
});

PJQ.collections.timecards.CrewWorkers = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.CrewWorker,
});

PJQ.collections.timecards.Equipment = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.Equipment,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push({
                endpoint: 'equipment'
            });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    _prepareModel: function(attrs, options) {
        options = options || {};
        options.projectId = this.options.projectId;
        return Backbone.Collection.prototype._prepareModel.call(this, attrs, options);
    },
    batchUpdate: function(addIds, deleteIds, callback) {
        if(!this.options.projectId)
            return;

        new PJQ.ajax.Request({
            endpoint: `${this.endpoint()}/batch`,
            data: {
                addIds: addIds,
                deleteIds: deleteIds
            },
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    }
});
PJQ.views.timecards.TimeCardSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-timecard-settings'),
        width: '400px'
    },
    events: {
        'change .select-column': 'columnSelected',
        'click button.settings-save': 'onSave',
        'click .btn-geofence': 'manageProjectGeofence'
    },
    beforeModalCreated: function () {
        this.model = this.options.timecardsView.userSettings;
    },
    beforeRender: function () {
        // copy settings for our UI; we only update global settings object on save.
        this.options.settings = [];
        this.options.defaultView = this.model.get('defaultView');
        this.options.defaultDateRange = this.model.get('defaultDateRange');
        _.each(this.model.attributes.viewSettings, _.bind(function (setting) {
            if (setting.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD ||
                setting.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD)
                return;

            let columns = this.options.timecardsView.getDataTableInstance({
                    view: setting.view,
                    timeCardSettings: this.options.timecardsView.settings,
                    settings: this.model.getSettings(setting.view)
                }).getColumns(true)

            columns =  _.filter(columns, (col) => {
                return col.visible !== false;
            })

            let selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.settings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.timecardsView.options.project
        }
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view-default'),
            defaultValue: this.options.defaultView,
            onChange: _.bind(function (value) {
                this.options.defaultView = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-date-range-default'),
            defaultValue: this.options.defaultDateRange,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.options.defaultDateRange = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view'),
            defaultValue: this.options.timecardsView.dataTable.options.view,
            onChange: _.bind(function (value) {
                this.selectView(value);
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(this.options.timecardsView.dataTable.options.view);
    },
    manageProjectGeofence: function () {
        new PJQ.views.timecards.TimeCardGeofenceModal({});
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.settings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.$('div.rows-per-page').show();
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
        } else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            order: [],
            pageLength: 5,
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.model.set('defaultView', this.options.defaultView);
        this.model.set('defaultDateRange', this.options.defaultDateRange);

        _.each(this.options.settings, _.bind(function (settingTemp) {
            _.each(this.model.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        } else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        //save settings to database
        this.model.save(null, {
            success: _.bind(function () {
                this.model.set('defaultView', this.options.defaultView);
                fnOnSave();
            }, this)
        });
    }
});

PJQ.views.timecards.TimeCardGeofenceModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-timecard-geofence'),
        minWidth: '700px'
    },
    events: {
        'keyup .input-longitude, .input-latitude, .input-radius': 'positionChanged',
        'click .btn-save': 'save',
        'click .cb-enable-geofence': 'toggleStatus'
    },
    beforeModalCreated: function () {
        this.settings = new PJQ.models.timecards.TimeCardSettings(null, {
            project: PJQ.app.session.project
        });

        this.geofenceEnabled = false;

        if (!this.settings.isFetched) {
            this.settings.fetch({
                success: _.bind(function () {
                    if (this.settings.get('geofence')) {
                        this.geofence = this.settings.get('geofence');
                        this.geofenceEnabled = this.geofence.latitude && this.geofence.longitude;
                    } else {
                        let defaultLat = PJQ.app.session.project.get('latitude'),
                            defaultLong = PJQ.app.session.project.get('longitude');
                        this.geofence = {
                            radius: 1000,
                            longitude: defaultLong !== 0 ? defaultLong : null,
                            latitude: defaultLat !== 0 ? defaultLat : null
                        };
                    }

                    this.isFetched = true;
                    this.render();
                }, this)
            })
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    renderData: function () {
        return {
            geofence: this.geofence,
            geofenceEnabled: this.geofenceEnabled
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        if (this.settings && this.settings.isFetched) {
            this.renderMap();
        }
    },
    toggleStatus: function () {
        this.geofenceEnabled = !this.geofenceEnabled;
    },
    renderMap: function () {
        this.geofenceMap = new PJQ.maps.GoogleMap(this.$('.geofence-map'));
        if (this.geofence.latitude && this.geofence.longitude) {
            this.refreshMarkers();
        }

        // Listen for clicks on the map to set/move the marker and radius circle
        this.geofenceMap.map.addListener('click', _.bind((data) => {
            // Reduce the lat/long to 7 decimal places
            this.geofence.latitude = Math.round(data.latLng.lat() * 10000000) / 10000000;
            this.geofence.longitude = Math.round(data.latLng.lng() * 10000000) / 10000000;
            this.geofenceEnabled = true;

            this.$('.cb-enable-geofence').prop('checked', true);
            this.$('.input-latitude').val(this.geofence.latitude);
            this.$('.input-longitude').val(this.geofence.longitude);

            this.refreshMarkers();
        }, this));
    },
    positionChanged: function (e) {
        let $target = $(e.currentTarget),
            valueType = $target.data('type'),
            value = $target.val();

        // Radius should always have a value
        if (valueType.toLowerCase() === 'radius') {
            value = parseInt(value);
            if (isNaN(value) || value < 0) {
                value = 0;
            }
            this.$('.input-radius').val(value);
        }

        this.geofence[valueType] = value;

        if (this.geofence.latitude && this.geofence.longitude) {
            this.refreshMarkers();
        }
    },
    refreshMarkers: function () {
        let positionObject = new google.maps.LatLng(this.geofence.latitude, this.geofence.longitude);

        if (this.geofence.radius == null) {
            this.geofence.radius = 1000;
            this.$('.input-radius').val(this.geofence.radius);
        }

        // if no marker and circle exist, create them
        if (!this.marker && !this.circle) {
            this.circle = new google.maps.Circle({
                map: this.geofenceMap.map,
                radius: this.geofence.radius ? this.geofence.radius : 1000,
                fillColor: '#41c1e1',
                fillOpacity: 0.35,
                strokeColor: '#148fb2',
                strokeOpacity: 0.8,
                strokeWeight: 1,
                center: positionObject,
                clickable: false
            });

            this.marker = new google.maps.Marker({
                position: positionObject,
                map: this.geofenceMap.map,
                title: 'Geofence Center',
                animation: google.maps.Animation.DROP
            });

            // Zoom and center map on marker when clicked
            this.marker.addListener('click', _.bind(function () {
                this.geofenceMap.setCenter(this.marker.getPosition());
                this.geofenceMap.setZoom(10);
            }, this));

            // Zoom and center map on marker on creation
            this.geofenceMap.setCenter(this.marker.getPosition());
            this.geofenceMap.setZoom(10);
        } else {
            this.marker.setPosition(positionObject);
            this.circle.setCenter(positionObject);
            this.circle.setRadius(this.geofence.radius);
        }
    },
    save: function () {
        if (!this.geofenceEnabled) {
            this.geofence.latitude = null;
            this.geofence.longitude = null;
        }

        this.settings.set('geofence', this.geofence);
        this.settings.save(null, {
            success: _.bind(function () {
                this.removeModal();
            }, this)
        })
    }
});

PJQ.views.timecards.TimeCardLocationMapModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-timecard-location-map'),
        minWidth: '700px',
        coordinatesIn: null,
        coordinatesOut: null
    },
    afterRender: function () {
        this.renderMap();
    },
    renderMap: function () {
        this.map = new PJQ.maps.GoogleMap(this.$('.timecard-location-map'));
        this.renderMarkers();
    },
    renderMarkers: function () {
        let inMarker = null,
            outMarker = null
        if (this.model.get('latitudeIn') && this.model.get('longitudeIn')) {
            inMarker = new google.maps.Marker({
                position: new google.maps.LatLng(this.model.get('latitudeIn'), this.model.get('longitudeIn')),
                map: this.map.map,
                title: 'Clock In Location',
                animation: google.maps.Animation.DROP,
                icon: {
                    url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                }
            });

            // Clock in info window
            let infoWindowContent = "<div class='p-1 text-align-center'><div class='font-weight-bold mb-1'>Clocked In</div>";

            if (this.model.get('timeIn')) {
                infoWindowContent += "<div>" + PJQ.helpers.dateHelpers.getDateString(this.model.get('timeIn'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "</div>";
            }
            infoWindowContent += "</div>"

            let infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });
            inMarker.addListener('click', function () {
                infoWindow.open(this.map, inMarker);
            });
        }

        if (this.model.get('latitudeOut') && this.model.get('longitudeOut')) {
            outMarker = new google.maps.Marker({
                position: new google.maps.LatLng(this.model.get('latitudeOut'), this.model.get('longitudeOut')),
                map: this.map.map,
                title: 'Clock Out Location',
                animation: google.maps.Animation.DROP,
                icon: {
                    url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                }
            });

            // Clock out info window
            let infoWindowContent = "<div class='p-1 text-align-center'><div class='font-weight-bold mb-1'>Clocked Out</div>";

            if (this.model.get('timeOut')) {
                infoWindowContent += "<div>" + PJQ.helpers.dateHelpers.getDateString(this.model.get('timeOut'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "</div>";
            }
            infoWindowContent += "</div>"

            let infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });
            outMarker.addListener('click', function () {
                infoWindow.open(this.map, outMarker);
            });
        }

        if (inMarker || outMarker) {
            this.map.setCenter(inMarker ? inMarker.getPosition() : outMarker.getPosition());
            this.map.setZoom(10);
        }
    }
});
PJQ.views.timecards.TimeCardMain = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard'),
        isShowHeader: true,
        project: null,
        contact: null,
        useManualDateRange: false
    },
    events: {
        'click .btn-settings': 'settings',
        'keyup .input-search': 'searchChanged',
        'click .search': 'search',
        'click .clear-search': 'clearFilter',
        'click .new-timecards': 'addTimeCards',
        'click .approve-batch': 'approveBatchStart',
        'click .unapprove-batch': 'approveBatchStart',
        'click .approval-continue': 'approveBatchContinue',
        'click .cancel-approval': 'approveBatchCancel',
        'click .export': 'exportList',
        'click .export-weekly': 'exportWeekly',
        'click .btn-manual-range': 'manualDateRange',
        'click .btn-auto-range': 'autoDateRange',
        'click .btn-prev-date': 'prevDateRange',
        'click .btn-next-date': 'nextDateRange'
    },
    beforeFirstRender: function () {
        this.selectedTimeCards = [];
        this.selectionMode = PJQ.constants.timecards.selectionMode.NONE;

        if (this.options.project != null) {
            this.options.permissions = PJQ.app.session.project.permissions;
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;
        }

        this.isFetched = false;
        this.userSettings = new PJQ.models.timecards.TimeCardUserSettings();
        this.userSettings.fetch({
            success: _.bind(function () {
                this.settings = new PJQ.models.timecards.TimeCardSettings(null, {
                    contact: this.options.contact,
                    project: this.options.project
                });
                this.settings.fetch({
                    success: _.bind(function () {
                        this.isFetched = true;
                        this.currentView = this.userSettings.get('defaultView');
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    beforeRender: function () {
        if (this.isFetched) {
            this.options.canAdd = this.options.permissions.hasPermission('timeCards.canAdd');
            this.options.canApprove = this.options.permissions.hasPermission('timeCards.canApprove');
            this.options.canViewAll = this.options.permissions.hasPermission('timeCards.canViewAll');
            this.options.isAdmin = this.options.permissions.hasPermission('timeCards.isAdmin');
        }
    },
    renderData: function () {
        return {
            showHeader: this.options.isShowHeader,
            project: this.options.project,
            contact: this.options.contact,
            useManualDateRange: this.options.useManualDateRange,
            canAdd: this.options.canAdd,
            canApprove: this.options.canApprove,
            canViewAll: this.options.canViewAll,
            isAdmin: this.options.isAdmin,
            isFetched: this.options.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.viewSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.timecards-view'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: this.options.project ? PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD : this.userSettings.get('defaultView'),
            onHide: _.bind(function () {
                if (this.currentView !== this.viewSelectPicker.getValue())
                    this.renderView();
            }, this)
        });

        this.renderView();

        this.renderTotals();
    },
    renderTotals: function () {
        if (this.options.project == null || !this.options.isAdmin) {
            return;
        }

        this.options.project.fetchBudgetTimeStats((stats) => {
            let $totals = this.$('.timecard-totals');
            if (!stats) {
                $totals.empty();
                return;
            }

            $totals.html(`
                <div class="card p-2 wd-150p mr-3 ml-3 elevation-1 text-align-center text-dark">
                    <div class="fs-16 font-weight-light lh-20">
                        Budgeted Hours
                    </div>
                    <div class="total-projected fs-18 font-weight-medium lh-20">
                        ${PJQ.helpers.formatHelpers.minutesToHHMM(stats.budgetedHours)}
                    </div>
                </div>
                <div class="card p-2 wd-150p mr-3 ml-3 elevation-1 text-align-center text-dark">
                    <div class="fs-16 font-weight-light lh-20">
                        Actual Hours
                    </div>
                    <div class="fs-18 font-weight-medium lh-20">
                        ${PJQ.helpers.formatHelpers.minutesToHHMM(stats.actualHours)}
                    </div>
                </div>`
            );
        });
    },
    manualDateRange: function () {
        this.options.useManualDateRange = true;
        this.render();
    },
    autoDateRange: function () {
        this.options.useManualDateRange = false;
        this.render();
    },
    renderDateRange: function () {
        let dateRange = this.userSettings.get('defaultDateRange');
        if (!this.options.useManualDateRange) {
            switch (dateRange) {
                case PJQ.constants.timecards.defaultDateRange.DAYS_30:
                    if (this.startDate == null) {
                        this.startDate = new Date();
                    }
                    this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 29);
                    break;
                case PJQ.constants.timecards.defaultDateRange.WEEK_TO_DATE:
                    if (this.startDate == null) {
                        this.startDate = new Date();
                        switch (this.settings.get('weekStart')) {
                            case 0: // Su
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay()) % 7);
                                break;
                            default:
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() + (7 - this.settings.get('weekStart'))) % 7);
                                break;
                        }

                        this.endDate = new Date();
                    } else {
                        this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 6);
                    }
                    break;
                case PJQ.constants.timecards.defaultDateRange.MONTH_TO_DATE:
                    if (this.startDate == null) {
                        this.startDate = PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getCurrentYear() + '-' + PJQ.helpers.dateHelpers.getCurrentMonth() + '-01 00:00:00');
                        this.endDate = new Date();
                    } else {
                        this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 29);
                    }
                    break;
                default:
                    if (this.startDate == null) {
                        this.startDate = new Date();
                        switch (this.settings.get('weekStart')) {
                            case 0: // Su
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay()) % 7);
                                break;
                            default:
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() + (7 - this.settings.get('weekStart'))) % 7);
                                break;
                        }
                    }

                    this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, dateRange - 1);
                    break;
            }
        } else if (this.startDate == null) {
            this.startDate = new Date();
            this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, dateRange - 1);
        }

        if (this.options.useManualDateRange) {
            if (this.startDatePicker) {
                this.startDatePicker.remove();
            }
            if (this.endDatePicker) {
                this.endDatePicker.remove();
            }

            this.startDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.start-date'),
                datepickerOptions: {
                    defaultDate: this.startDate,
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                },
                onChange: _.bind(function (value) {
                    this.selectedTimeCards = [];
                    this.startDate = value;
                    this.renderView();
                }, this)
            });

            this.endDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.end-date'),
                datepickerOptions: {
                    defaultDate: this.endDate,
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                },
                onChange: _.bind(function (value) {
                    this.selectedTimeCards = [];
                    this.endDate = value;
                    this.renderView();
                }, this)
            });
        } else {
            let startDateString = PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE),
                endDateString = PJQ.helpers.dateHelpers.getDateString(this.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
            this.$('.date-range-display').text(startDateString + ' - ' + endDateString);
        }
    },
    prevDateRange: function () {
        let dateRange = this.userSettings.get('defaultDateRange');
        switch (dateRange) {
            case PJQ.constants.timecards.defaultDateRange.WEEK_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, -7);
                break;
            case PJQ.constants.timecards.defaultDateRange.MONTH_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, -30);
                break;
            default:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, -dateRange);
                break;
        }
        this.renderView();
    },
    nextDateRange: function () {
        let dateRange = this.userSettings.get('defaultDateRange');
        switch (dateRange) {
            case PJQ.constants.timecards.defaultDateRange.WEEK_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 7);
                break;
            case PJQ.constants.timecards.defaultDateRange.MONTH_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 30);
                break;
            default:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, dateRange);
                break;
        }
        this.renderView();
    },
    renderView: function (view, options = {}) {
        this.currentView = view ? view : this.viewSelectPicker.getValue();

        this.renderDateRange();

        PJQ.helpers.inputHelpers.setInputError(this.$('.start-date, .end-date'), true);
        if (this.startDate > this.endDate) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.start-date, .end-date'), false);
            return;
        }

        let page = null;
        if (options.stayOnPage && this.dataTable != null) {
            page = this.dataTable.dataTable.page();
        }


        if (this.dataTable) {
            this.dataTable.cleanup();
            this.dataTable.clearServerCache = true;
            this.dataTable.pageCache = [];
            this.dataTable.remove();
            this.dataTable = null;
            this.$('.timecards-data').empty();
        }

        let tableSettings = this.userSettings.getSettings(this.currentView),
            dataTableOptions = {
                el: this.$('.timecards-data'),
                language: {
                    zeroRecords: 'No Results Available'
                },
                data: null,
                project: this.options.project,
                view: this.currentView,
                timecardsView: this,
                timeCardSettings: this.settings,
                settings: tableSettings,
                userSettings: this.userSettings,
                getPageCallback: _.bind(this.getViewData, this),
                displayStart: page != null ? page * tableSettings.rowsPerPage : null,
                deferRender: true,
                clearServerCache: true,
                showPageSelector: true,
                onChange: () => {
                    this.renderTotals();
                },
                onApprove: (timecards, approve, callback) => {
                    if (timecards == null) {
                        return;
                    }

                    let ids;
                    if (PJQ.helpers.objectHelpers.refinedType(timecards) === 'array') {
                        ids = _.map(_.filter(timecards, (tc) => {
                            return approve ? tc.get('approvedOn') == null : tc.get('approvedOn') != null;
                        }), (tc) => {
                            return tc.id;
                        });
                    } else if (timecards.id != null) {
                        ids = [timecards.id];
                    }

                    let tcCount = _.size(ids);
                    if (tcCount > 0) {
                        this.approveTimeCards(ids, approve, (response) => {
                            PJQ.notifications.notify.successNotify({
                                message: tcCount.toString() + ' Time Cards successfully ' + (approve ? 'approved' : 'unapproved')
                            });
                            if (typeof callback === 'function') {
                                callback(response);
                            }
                        });
                    }
                },
                onTableDraw: (dataTable) => {
                    this.$('.timecards-data').css('margin-top', -40);
                },
                colReorder: {
                    fixedColumnsLeft: 1,
                    fixedColumnsRight: (this.currentView === PJQ.constants.timecards.view.BY_TIMECARD || this.currentView === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD) ? 1 : 0,
                    realtime: false
                }
            };

        this.dataTable = this.getDataTableInstance(dataTableOptions);
    },
    getViewData: function (pageNumber, pageSize, orderArr, callback) {
        let order = orderArr[0];
        this.data = null;

        switch (this.currentView) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                this.data = new PJQ.collections.timecards.TimeCards();
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
                this.data = new PJQ.collections.timecards.TimeCardProjects();
                break;
            case PJQ.constants.timecards.view.BY_CONTACT:
                this.data = new PJQ.collections.timecards.TimeCardContacts();
                break;
        }

        let idFilter = 0;
        if (this.options.contact)
            idFilter = this.options.contact.id;
        else {
            if ((PJQ.app.session.systemPermissions == null || !PJQ.app.session.systemPermissions.hasPermission('contacts.canView')) && (PJQ.app.session.project === null || this.options.permissions.hasPermission('canViewAll')))
                idFilter = -PJQ.app.session.user.id;
        }
        let dateNow = new Date(),
            parameters = {
                searchFor: this.$('.input-search').val(),
                startDate: PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                endDate: PJQ.helpers.dateHelpers.getDateString(this.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                page: pageNumber,
                pageSize: pageSize,
                orderBy: order.name,
                orderDirection: order.direction,
                timeZoneOffset: dateNow.getTimezoneOffset(),
                projectId: this.options.project ? this.options.project.get('projectId') : 0,
                idFilter: idFilter
            };

        this.data.fetch({
            data: parameters,
            success: _.bind(function () {
                callback(this.data.models, this.data.totalRows);
            }, this),
            fail: _.bind(function () {
                callback();
            }, this)
        });
    },
    getDataTableInstance: function (options) {
        let dataTable = null;

        switch (options.view) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                dataTable = new PJQ.views.timecards.TimeCardDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
                dataTable = new PJQ.views.timecards.ProjectDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_PROJECT_CONTACT:
                dataTable = new PJQ.views.timecards.ContactDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD:
                dataTable = new PJQ.views.timecards.TimeCardDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_CONTACT:
                dataTable = new PJQ.views.timecards.ContactDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_CONTACT_PROJECT:
                dataTable = new PJQ.views.timecards.ProjectDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD:
                dataTable = new PJQ.views.timecards.TimeCardDataTable(options);
                break;
        }
        return dataTable;
    },
    searchChanged: function (e) {
        if (e.keyCode === 13) {
            this.selectedTimeCards = [];
            this.search();
        }
    },
    search: function () {
        this.renderView();
    },
    clearFilter: function () {
        this.$('.input-search').val('');
        this.renderView();
    },
    settings: function () {
        new PJQ.views.timecards.TimeCardSettingsModal({
            timecardsView: this,
            onSave: _.bind(function () {
                this.startDate = null;
                this.endDate = null;
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    addTimeCards: function () {
        if (!this.options.canAdd) {
            return;
        }

        if (this.settings.get('enableLineItems') || this.settings.get('enableClockIn')) {
            new PJQ.views.timecards.AddTimeCardsModal({
                project: this.options.project,
                settings: this.settings,
                onSave: () => {
                    this.renderView(this.currentView, {stayOnPage: true});
                    this.renderTotals();
                }
            });
        } else {
            new PJQ.views.timecards.ManageTimeCardsByWeekModal({
                timecardsView: this,
                settings: this.settings,
                project: this.options.project,
                contact: this.options.contact,
                onSave: () => {
                    this.renderView(this.currentView, {stayOnPage: true});
                    this.renderTotals();
                }
            });
        }
    },
    approveBatchStart: function (e) {
        this.selectionMode = $(e.currentTarget).hasClass('approve-batch') ? PJQ.constants.timecards.selectionMode.APPROVE : PJQ.constants.timecards.selectionMode.UNAPPROVE;
        this.$('.approval-continue').prop('disabled', _.size(this.selectedTimeCards) === 0);
        switch (this.currentView) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                this.renderView(null, {stayOnPage: true});
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
            case PJQ.constants.timecards.view.BY_CONTACT:
                _.each(this.dataTable.options.childDataTables, _.bind(function (childDT) {
                    _.each(childDT.options.childDataTables, _.bind(function (grandChildDT) {
                        childDT.renderChildRow(childDT.getRow(grandChildDT.$el.closest('tr').prev()), grandChildDT.options.parentId);
                    }, this));
                }, this));
                break;
        }

        this.showNotification('Select 1 or more Time Cards and click "' + (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE ? 'Approve' : 'Un-Approve') + ' Checked" to continue.', 'info');
        this.$('.approval-continue').text((this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE ? 'Approve' : 'Un-Approve') + ' Checked');
        this.$('.new-timecards, .other-actions').prop('disabled', true);
        this.$('.approval-continue, .cancel-approval').show();
    },
    approveBatchCancel: function () {
        this.selectionMode = PJQ.constants.timecards.selectionMode.NONE;
        this.selectedTimeCards = [];

        switch (this.currentView) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                this.renderView(null, {stayOnPage: true});
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
            case PJQ.constants.timecards.view.BY_CONTACT:
                _.each(this.dataTable.options.childDataTables, _.bind(function (childDT) {
                    _.each(childDT.options.childDataTables, _.bind(function (grandChildDT) {
                        childDT.renderChildRow(childDT.getRow(grandChildDT.$el.closest('tr').prev()), grandChildDT.options.parentId);
                    }, this));
                }, this));
                break;
        }

        this.$('.new-timecards, .other-actions').prop('disabled', false);
        this.$('.approval-continue, .cancel-approval').hide();
        this.hideNotification();
    },
    approveBatchContinue: function () {
        let isApproved = (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE);
        new PJQ.views.modals.YesNo({
            header: "Confirm " + (isApproved ? 'Approval' : 'Un-Approval'),
            body: "Are you sure you want to " + (isApproved ? 'approve' : 'un-approve') + " " + _.size(this.selectedTimeCards) + " Time Card" + (_.size(this.selectedTimeCards) > 1 ? "s" : "") + "?",
            onYes: _.bind(function () {
                this.approveTimeCards(this.selectedTimeCards, isApproved, _.bind(function () {
                    let plural = _.size(this.selectedTimeCards) > 0 ? 's' : '';
                    this.approveBatchCancel();
                    PJQ.notifications.notify.successNotify({
                        message: 'Time Card' + plural + ' ' + (isApproved ? 'approved' : 'unapproved')
                    });
                }, this));
            }, this)
        });
    },
    approveTimeCards: function (timeCardIds, isApproved, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'timecards',
                },
                {
                    endpoint: 'batch',
                },
                {
                    endpoint: 'approve'
                }
            ]),
            data: {
                timeCardIds: timeCardIds,
                isApproved: isApproved
            },
            isAPIv2: true
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(response);
            }
        }, this));
    },
    addSelectedTimeCards: function (timeCardIds) {
        this.selectedTimeCards = _.uniq(_.union(timeCardIds, this.selectedTimeCards));

        if (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE || this.selectionMode === PJQ.constants.timecards.selectionMode.UNAPPROVE)
            this.$('.approval-continue').prop('disabled', _.size(this.selectedTimeCards) === 0);
    },
    removeSelectedTimeCards: function (timeCardIds) {
        this.selectedTimeCards = _.without(this.selectedTimeCards, ...timeCardIds);

        if (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE || this.selectionMode === PJQ.constants.timecards.selectionMode.UNAPPROVE)
            this.$('.approval-continue').prop('disabled', _.size(this.selectedTimeCards) === 0);
    },
    hideNotification: function () {
        this.$('.timecard-notifications').hide();
    },
    showNotification: function (content, type) {
        this.$('.timecard-notifications').removeClass('alert-primary').removeClass('alert-secondary').removeClass('alert-info').removeClass('alert-success').removeClass('alert-warning').removeClass('alert-danger');
        this.$('.timecard-notifications').addClass('alert-' + type);

        let icon = '';
        switch (type) {
            case 'info':
                icon = '<i class="fas fa-info-circle fa-xs"></i>';
                break;
        }

        this.$('.timecard-notifications').html(icon + (icon ? ' ' : '') + content);
        this.$('.timecard-notifications').show();
    },
    export: function (view) {
        let parameters = [
            {
                parameter: 'searchFor',
                value: this.$('.input-search').val()
            },
            {
                parameter: 'startDate',
                value: PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
            },
            {
                parameter: 'endDate',
                value: PJQ.helpers.dateHelpers.getDateString(this.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
            },
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            },
            {
                parameter: 'projectId',
                value: this.options.project ? this.options.project.get('projectId') : 0
            },
            {
                parameter: 'idFilter',
                value: this.options.contact ? this.options.contact.id : 0
            },
            {
                parameter: 'view',
                value: view
            }
        ];

        let downloadEndpoint = [
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'export'
            }
        ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint(downloadEndpoint, parameters), {isAPIv2: true});
    },
    exportList: function () {
        this.export('timecard-list');
    },
    exportWeekly: function () {
        let template = 'timecard-weekly';
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.TIMECARD_WEEKLY_EXPORT_TEMPLATE))
            template = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.TIMECARD_WEEKLY_EXPORT_TEMPLATE);
        this.export(template);
    }
});